export const notarias = [
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO - FERNANDO MANTEROLA SALAS",
  commune: "ARICA",
  displayName: "NOTARÍA DE ARICA, DE DON CONSERVADOR Y ARCHIVERO - FERNANDO MANTEROLA SALAS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - RODRIGO LAZCANO ARRIAGADA",
  commune: "ARICA",
  displayName: "PRIMERA NOTARÍA DE ARICA, DE DON RODRIGO LAZCANO ARRIAGADA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - MARIO PALMA SOTOMAYOR (INTERINO)",
  commune: "ARICA",
  displayName: "SEGUNDA NOTARÍA DE ARICA, DE DON MARIO PALMA SOTOMAYOR (INTERINO)",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - OSCAR PATRICIO SOTO HERNÁNDEZ",
  commune: "ARICA",
  displayName: "TERCERA NOTARÍA DE ARICA, DE DON OSCAR PATRICIO SOTO HERNÁNDEZ",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - HUGO HUMBERTO VILCHES FUENTES (INTERINO)",
  commune: "ARICA",
  displayName: "CUARTA NOTARÍA DE ARICA, DE DON HUGO HUMBERTO VILCHES FUENTES (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO - ENZO REDOLFI GONZALEZ",
  commune: "IQUIQUE",
  displayName: "NOTARÍA NOTARÍA DE IQUIQUE, DE DON CONSERVADOR Y ARCHIVERO - ENZO REDOLFI GONZALEZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - RODRIGO ALEJANDRO GONZÁLEZ BARRIGA",
  commune: "IQUIQUE",
  displayName: "PRIMERA NOTARÍA DE IQUIQUE, DE DON RODRIGO ALEJANDRO GONZÁLEZ BARRIGA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - HEIDI PATRICIA CAVIERES ARAYA",
  commune: "IQUIQUE",
  displayName: "SEGUNDA NOTARÍA DE IQUIQUE, DE HEIDI PATRICIA CAVIERES ARAYA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - NÉSTOR ARAYA BLAZINA",
  commune: "IQUIQUE",
  displayName: "TERCERA NOTARÍA DE IQUIQUE, DE NÉSTOR ARAYA BLAZINA",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - RUBEN ESCOBAR GARCÍA (INTERINO)",
  commune: "IQUIQUE",
  displayName: "CUARTA NOTARÍA DE IQUIQUE, DE DON RUBEN ESCOBAR GARCÍA (INTERINO)",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - DARIO CHACÓN VICENTELO",
  commune: "TARAPACÁ",
  displayName: "QUINTA NOTARÍA DE TARAPACÁ, DE DON DARIO CHACÓN VICENTELO",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA - ANDRÉS CUEVAS OSSANDÓN",
  commune: "IQUIQUE",
  displayName: "SEXTA NOTARÍA DE IQUIQUE, DE DON ANDRÉS CUEVAS OSSANDÓN",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA ASTO ALTO HOSPICIO - PAULO CESAR CORTÉS OLGUÍN",
  commune: "5 Y 5B, ALTO HOSPICIO",
  displayName: "SÉPTIMA NOTARÍA DE 5 Y 5B, ALTO HOSPICIO, DE DON 7A NOTARÍA ASTO ALTO HOSPICIO - PAULO CESAR CORTÉS OLGUÍN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO - JUAN ANDRÉS RIVEROS DONOSO",
  commune: "ALTO HOSPICIO",
  displayName: "NOTARÍA NOTARÍA DE ALTO HOSPICIO, DE DON CONSERVADOR Y ARCHIVERO - JUAN ANDRÉS RIVEROS DONOSO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO, ENSO GONZÁLEZ GONZÁLEZ",
  commune: "POZO ALMONTE",
  displayName: "NOTARÍA NOTARÍA DE POZO ALMONTE, DE DON CONSERVADOR Y ARCHIVERO, ENSO GONZÁLEZ GONZÁLEZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ANGIELLO PAOLO CORDANO CARRIZO (INTERINO)",
  commune: "POZO ALMONTE",
  displayName: "PRIMERA NOTARÍA DE POZO ALMONTE, DE DON ANGIELLO PAOLO CORDANO CARRIZO (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR BS RS, COMERCIO Y ARCHIVERO - JUAN JOSÉ VELOSO MORA",
  commune: "ANTOFAGASTA",
  displayName: "NOTARÍA NOTARÍA DE ANTOFAGASTA, DE DON CONSERVADOR BS RS, COMERCIO Y ARCHIVERO - JUAN JOSÉ VELOSO MORA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - CAROLINA LEIVA PÉREZ (INTERINA)",
  commune: "ANTOFAGASTA",
  displayName: "PRIMERA NOTARÍA DE ANTOFAGASTA, DE DON CAROLINA LEIVA PÉREZ (INTERINA)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - JULIO ABASOLO ARAVENA",
  commune: "ANTOFAGASTA",
  displayName: "SEGUNDA NOTARÍA DE ANTOFAGASTA, DE DON CONSERVADOR DE MINAS - JULIO ABASOLO ARAVENA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - GONZALO HURTADO PERALTA",
  commune: "ANTOFAGASTA",
  displayName: "TERCERA NOTARÍA DE ANTOFAGASTA, DE DON GONZALO HURTADO PERALTA",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - JUAN SANTIAGO TREUER MOYA",
  commune: "ANTOFAGASTA",
  displayName: "CUARTA NOTARÍA DE ANTOFAGASTA, DE DON JUAN SANTIAGO TREUER MOYA",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - CARLOS URBINA RESZCZYSNSKI",
  commune: "ANTOFAGASTA",
  displayName: "QUINTA NOTARÍA DE ANTOFAGASTA, DE DON CARLOS URBINA RESZCZYSNSKI",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA - FRANCISCO ARMANDO MARTINEZ TORRES",
  commune: "ANTOFAGASTA",
  displayName: "SEXTA NOTARÍA DE ANTOFAGASTA, DE DON FRANCISCO ARMANDO MARTINEZ TORRES",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA ANTOFAGASTA ASIENTO SIERRA GORDA - EMILIO SARMIENTO MORENO",
  commune: "BAQUEDANO",
  displayName: "SÉPTIMA NOTARÍA DE BAQUEDANO, DE DON EMILIO SARMIENTO MORENO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - DIEGO NICOLÁS MEJÍAS LARRAÍN",
  commune: "MEJILLONES",
  displayName: "NOTARÍA NOTARÍA DE MEJILLONES, DE DON NOTARÍA, CONSERVADOR Y ARCHIVERO - DIEGO NICOLÁS MEJÍAS LARRAÍN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - PABLO SÁNCHEZ PAREDES",
  commune: "TALTAL",
  displayName: "NOTARÍA NOTARÍA DE TALTAL, DE DON NOTARÍA, CONSERVADOR Y ARCHIVERO - PABLO SÁNCHEZ PAREDES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - ANDREA GODOY MUÑOZ (INTERINO)",
  commune: "TOCOPILLA",
  displayName: "NOTARÍA NOTARÍA DE TOCOPILLA, DE DON NOTARÍA, CONSERVADOR Y ARCHIVERO - ANDREA GODOY MUÑOZ (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - JOSÉ GAJARDO ALCAYAGA (INTERINO)",
  commune: "MARÍA ELENA",
  displayName: "NOTARÍA NOTARÍA DE MARÍA ELENA, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - JOSÉ GAJARDO ALCAYAGA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAICES, COMERCIO Y ARCHIVERO - ALVARO MAURICIO TOLEDO SOTO",
  commune: "CALAMA",
  displayName: "NOTARÍA NOTARÍA DE CALAMA, DE DON CONSERVADOR DE BIENES RAICES, COMERCIO Y ARCHIVERO - ALVARO MAURICIO TOLEDO SOTO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - MIGUELÁNGEL JIMÉNEZ SEGURA",
  commune: "CALAMA",
  displayName: "PRIMERA NOTARÍA DE CALAMA, DE DON MIGUELÁNGEL JIMÉNEZ SEGURA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS DE CALAMA - CRISTOBAL LY VALLOTTON",
  commune: "CALAMA",
  displayName: "SEGUNDA NOTARÍA DE CALAMA, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS DE CALAMA - CRISTOBAL LY VALLOTTON",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - ALEJANDRO GEMMEL MARTÍNEZ",
  commune: "CALAMA",
  displayName: "TERCERA NOTARÍA DE CALAMA, DE DON ALEJANDRO GEMMEL MARTÍNEZ",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - GONZALO MASANA PETERSEN (INTERINO)",
  commune: "CALAMA",
  displayName: "CUARTA NOTARÍA DE CALAMA, DE DON GONZALO MASANA PETERSEN (INTERINO)",
  prefix: "DOÑA"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA CALAMA ASTO SAN PEDRO DE ATACAMA - GISELA ARIADNE SCHWERTER HUAQUÍN",
  commune: "",
  displayName: "QUINTA NOTARÍA DE , DE DON 5A NOTARÍA CALAMA ASTO SAN PEDRO DE ATACAMA - GISELA ARIADNE SCHWERTER HUAQUÍN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - MARÍA CAROLINA VILCHES GUGGIANA",
  commune: "CHAÑARAL",
  displayName: "NOTARÍA NOTARÍA DE CHAÑARAL, DE DOÑA NOTARÍA, CONSERVADOR Y ARCHIVERO - MARÍA CAROLINA VILCHES GUGGIANA",
  prefix: "DOÑA"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA CONSERVADOR Y ARCHIVERO - JUAN JOSÉ CARVAJAL PALACIOS",
  commune: "DIEGO DE ALMAGRO",
  displayName: "NOTARÍA NOTARÍA DE DIEGO DE ALMAGRO, DE DON NOTARÍA CONSERVADOR Y ARCHIVERO - JUAN JOSÉ CARVAJAL PALACIOS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONS. BS. RS., COMERCIO Y ARCHIVERO - TOMÁS JARPA CONCHA",
  commune: "COPIAPÓ",
  displayName: "NOTARÍA NOTARÍA DE COPIAPÓ, DE DON CONS. BS. RS., COMERCIO Y ARCHIVERO - TOMÁS JARPA CONCHA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - FRANCISCO NEHME CARPANETTI",
  commune: "COPIAPÓ",
  displayName: "PRIMERA NOTARÍA DE COPIAPÓ, DE DON FRANCISCO NEHME CARPANETTI",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA, CONSERVADOR DE MINAS - LUIS ALBERTO CONTRERAS FUENTES",
  commune: "COPIAPÓ",
  displayName: "SEGUNDA NOTARÍA DE COPIAPÓ, DE DON LUIS ALBERTO CONTRERAS FUENTES",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - GABY HERNÁNDEZ SOTO",
  commune: "COPIAPÓ",
  displayName: "TERCERA NOTARÍA DE COPIAPÓ, DE GABY HERNÁNDEZ SOTO",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - CARLOS MORALES GONZÁLEZ (INTERINO)",
  commune: "COPIAPÓ, ATACAMA",
  displayName: "CUARTA NOTARÍA DE COPIAPÓ, ATACAMA, DE DON CARLOS MORALES GONZÁLEZ (INTERINO)",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA COPIAPÓ ASIENTO TIERRA AMARILLA - ANDRÉS CARLOS ZAVALA COURRIOL",
  commune: "TIERRA AMARILLA",
  displayName: "QUINTA NOTARÍA DE TIERRA AMARILLA, DE DON 5A NOTARÍA COPIAPÓ ASIENTO TIERRA AMARILLA - ANDRÉS CARLOS ZAVALA COURRIOL",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - CAROLINA MORENO JASHES",
  commune: "CALDERA",
  displayName: "NOTARÍA NOTARÍA DE CALDERA, DE DON NOTARÍA, CONSERVADOR Y ARCHIVERO - CAROLINA MORENO JASHES",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA Y CONSERVADOR DE BIENES RAICES - PEDRO ALFONSO AYLWIN VALENZUELA",
  commune: "VALLENAR",
  displayName: "PRIMERA NOTARÍA DE VALLENAR, DE DON 1A NOTARÍA Y CONSERVADOR DE BIENES RAICES - PEDRO ALFONSO AYLWIN VALENZUELA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA, CONSERVADOR DE COMERCIO, MINAS Y ARCHIVERO - RICARDO OLIVARES PIZARRO",
  commune: "LOC. 14, VALLENAR",
  displayName: "SEGUNDA NOTARÍA DE LOC. 14, VALLENAR, DE DON  RICARDO OLIVARES PIZARRO",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA DE VALLENAR ASTO ALTO DEL CARMEN, CONSERVADOR DE BIENES RAICES - FELIPE VELASQUEZ MORALES",
  commune: "",
  displayName: "TERCERA NOTARÍA DE VALLENAR, DE DON FELIPE VELASQUEZ MORALES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO - DARÍO SILVA MARCHANT",
  commune: "FREIRINA",
  displayName: "NOTARÍA NOTARÍA DE FREIRINA, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO - DARÍO SILVA MARCHANT",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO - JAIME MORANDE MIRANDA",
  commune: "LA SERENA",
  displayName: "NOTARÍA NOTARÍA DE LA SERENA, DE DON CONSERVADOR Y ARCHIVERO - JAIME MORANDE MIRANDA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - PEDRO FELIPE VILLARINO KRUMM",
  commune: "LA SERENA",
  displayName: "PRIMERA NOTARÍA DE LA SERENA, DE DON PEDRO FELIPE VILLARINO KRUMM",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - JESÚS ANTONIO OSSES REVECO",
  commune: "LA SERENA",
  displayName: "SEGUNDA NOTARÍA DE LA SERENA, DE DON JESÚS ANTONIO OSSES REVECO",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - PABLO IGNACIO BUSTOS MOLINA",
  commune: "LA SERENA",
  displayName: "TERCERA NOTARÍA DE LA SERENA, DE DON PABLO IGNACIO BUSTOS MOLINA",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - RUBÉN REINOSO HERRERA",
  commune: "LA SERENA",
  displayName: "CUARTA NOTARÍA DE LA SERENA, DE DON RUBÉN REINOSO HERRERA",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - MARIANO TORREALBA ZILIANI",
  commune: "LA SERENA",
  displayName: "QUINTA NOTARÍA DE LA SERENA, DE DON MARIANO TORREALBA ZILIANI",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA - ALEJANDRO TOMÁS VIADA OVALLE",
  commune: "LA SERENA",
  displayName: "SEXTA NOTARÍA DE LA SERENA, DE DON ALEJANDRO TOMÁS VIADA OVALLE",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVAODR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO - CECIRA FIGARI ROJAS",
  commune: "2O PISO , COQUIMBO",
  displayName: "NOTARÍA NOTARÍA DE 2O PISO , COQUIMBO, DE DON CONSERVAODR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO - CECIRA FIGARI ROJAS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - RODOLFO ESTEBAN POLANCO GALLOSO (INTERINO)",
  commune: "COQUIMBO",
  displayName: "PRIMERA NOTARÍA DE COQUIMBO, DE DON 1A NOTARÍA - RODOLFO ESTEBAN POLANCO GALLOSO (INTERINO)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - GONZALO HENRIQUE ENCAMILLA (INTERINO)",
  commune: "COQUIMBO",
  displayName: "SEGUNDA NOTARÍA DE COQUIMBO, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - GONZALO HENRIQUE ENCAMILLA (INTERINO)",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - JUAN CARLOS MATURANA LEPELEY",
  commune: "COQUIMBO.",
  displayName: "TERCERA NOTARÍA DE COQUIMBO., DE DOÑA 3A NOTARÍA - JUAN CARLOS MATURANA LEPELEY",
  prefix: "DOÑA"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - REINALDO VILLALOBOS PELLEGRINI",
  commune: "COQUIMBO",
  displayName: "CUARTA NOTARÍA DE COQUIMBO, DE DON 4A NOTARÍA - REINALDO VILLALOBOS PELLEGRINI",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - MARIA JOSE MONTESINO BIANCHI",
  commune: "COQUIMBO",
  displayName: "QUINTA NOTARÍA DE COQUIMBO, DE DON 5A NOTARÍA - MARIA JOSE MONTESINO BIANCHI",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - PATRICIO A. GUTIÉRREZ GAJARDO",
  commune: "COQUIMBO",
  displayName: "QUINTA NOTARÍA DE COQUIMBO, DE DON 5A NOTARÍA - PATRICIO A. GUTIÉRREZ GAJARDO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - DANIEL HURTADO NAVIA",
  commune: "VICUÑA",
  displayName: "NOTARÍA NOTARÍA DE VICUÑA, DE DON NOTARÍA, CONSERVADOR Y ARCHIVERO - DANIEL HURTADO NAVIA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - ANDREA BRAVO BARRÍA",
  commune: "ANDACOLLO",
  displayName: "NOTARÍA NOTARÍA DE ANDACOLLO, DE DON NOTARÍA, CONSERVADOR Y ARCHIVERO - ANDREA BRAVO BARRÍA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAICES, COMERCIO Y ARCHIVERO - FERNANDO PEÑAFIEL SALAS",
  commune: "OVALLE",
  displayName: "NOTARÍA NOTARÍA DE OVALLE, DE DON CONSERVADOR DE BIENES RAICES, COMERCIO Y ARCHIVERO - FERNANDO PEÑAFIEL SALAS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - FELIPE EDUARDO LEIVA ILABACA",
  commune: "OVALLE",
  displayName: "PRIMERA NOTARÍA DE OVALLE, DE DON 1A NOTARÍA - FELIPE EDUARDO LEIVA ILABACA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - RODRIGO CABRERA ALBARRÁN",
  commune: "OVALLE",
  displayName: "SEGUNDA NOTARÍA DE OVALLE, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - RODRIGO CABRERA ALBARRÁN",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - JOSÉ LUIS CONTRERAS MUNDACA",
  commune: "OVALLE",
  displayName: "TERCERA NOTARÍA DE OVALLE, DE DON 3A NOTARÍA - JOSÉ LUIS CONTRERAS MUNDACA",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - CARLOS GALLEGUILLOS CARVAJAL",
  commune: "OVALLE",
  displayName: "QUINTA NOTARÍA DE OVALLE, DE DON 5A NOTARÍA - CARLOS GALLEGUILLOS CARVAJAL",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA OVALLE ASIENTO MONTE PATRIA, CONSERVADOR DE BIENES RAÍCES - LILIAN NATALIA CÁRDENAS ELGUETA",
  commune: "MONTE PATRIA",
  displayName: "CUARTA NOTARÍA DE MONTE PATRIA, DE DON 4A NOTARÍA OVALLE ASIENTO MONTE PATRIA, CONSERVADOR DE BIENES RAÍCES - LILIAN NATALIA CÁRDENAS ELGUETA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR Y ARCHIVERO - PABLO ANDRÉS LAGOS FEEST (INTERINO)",
  commune: "COMBARBALÁ",
  displayName: "NOTARÍA NOTARÍA DE COMBARBALÁ, DE DON NOTARÍA, CONSERVADOR Y ARCHIVERO - PABLO ANDRÉS LAGOS FEEST (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAICES, COMERCIO Y ARCHIVERO - ARTURO SEREY CORTÉS",
  commune: "ILLAPEL",
  displayName: "NOTARÍA NOTARÍA DE ILLAPEL, DE DON CONSERVADOR DE BIENES RAICES, COMERCIO Y ARCHIVERO - ARTURO SEREY CORTÉS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA ILLAPEL Y CONSERVADOR DE MINAS - PAULINA ALEJANDRA TORO MARANGUNIC (INTERINA)",
  commune: "ILLAPEL",
  displayName: "PRIMERA NOTARÍA DE ILLAPEL, DE DON 1A NOTARÍA ILLAPEL Y CONSERVADOR DE MINAS - PAULINA ALEJANDRA TORO MARANGUNIC (INTERINA)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA ILLAPEL ASTO SALAMANCA - SERGIO ENRIQUE PERALTA MORALES",
  commune: "SALAMANCA",
  displayName: "SEGUNDA NOTARÍA DE SALAMANCA, DE DON 2A NOTARÍA ILLAPEL ASTO SALAMANCA - SERGIO ENRIQUE PERALTA MORALES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO - MARIO OLMOS LOPOMO",
  commune: "LOS VILOS",
  displayName: "NOTARÍA NOTARÍA DE LOS VILOS, DE DON CONSERVADOR Y ARCHIVERO - MARIO OLMOS LOPOMO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA - PABLO RODRIGO BARRANTES DÍAZ",
  commune: "LOS VILOS",
  displayName: "NOTARÍA NOTARÍA DE LOS VILOS, DE DON NOTARÍA - PABLO RODRIGO BARRANTES DÍAZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y COMERCIO - RICARDO VALDERRAMA LATHROP",
  commune: "VALPARAÍSO",
  displayName: "NOTARÍA NOTARÍA DE VALPARAÍSO, DE DON CONSERVADOR DE BIENES RAÍCES Y COMERCIO - RICARDO VALDERRAMA LATHROP",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA Y CONSERVADOR DE MINAS - ENZO REPETTO LUES (INTERINO)",
  commune: "VALPARAÍSO",
  displayName: "PRIMERA NOTARÍA DE VALPARAÍSO, DE DON 1A NOTARÍA Y CONSERVADOR DE MINAS - ENZO REPETTO LUES (INTERINO)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y ARCHIVERO - MARCELA TAVOLARI OLIVEROS",
  commune: "VALPARAÍSO",
  displayName: "SEGUNDA NOTARÍA DE VALPARAÍSO, DE DON 2A NOTARÍA Y ARCHIVERO - MARCELA TAVOLARI OLIVEROS",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - PAOLA DEBORAH STACK LARA",
  commune: "VALPARAÍSO",
  displayName: "TERCERA NOTARÍA DE VALPARAÍSO, DE DON 3A NOTARÍA - PAOLA DEBORAH STACK LARA",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - PABLO CONTRERAS GUERRERO (INTERINO)",
  commune: "VALPARAÍSO",
  displayName: "CUARTA NOTARÍA DE VALPARAÍSO, DE DON 4A NOTARÍA - PABLO CONTRERAS GUERRERO (INTERINO)",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - CARLOS WENDT (INTERINO)",
  commune: "VALPARAÍSO",
  displayName: "QUINTA NOTARÍA DE VALPARAÍSO, DE DON 5A NOTARÍA - CARLOS WENDT (INTERINO)",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA - CLAUDIA PAOLA OLGUIN VARGAS",
  commune: "VALPARAÍSO",
  displayName: "SEXTA NOTARÍA DE VALPARAÍSO, DE DON 6A NOTARÍA - CLAUDIA PAOLA OLGUIN VARGAS",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA - JOSÉ FRANCISCO OLATE GONZÁLEZ (INTERINO)",
  commune: "VALPARAÍSO",
  displayName: "SÉPTIMA NOTARÍA DE VALPARAÍSO, DE DON 7A NOTARÍA - JOSÉ FRANCISCO OLATE GONZÁLEZ (INTERINO)",
  prefix: "DON"
},
{
  num: "OCTAVA",
  name: "8A NOTARÍA - LUIS FELIPE SEPÚLVEDA PONCE",
  commune: "VALPARAÍSO",
  displayName: "OCTAVA NOTARÍA DE VALPARAÍSO, DE DON 8A NOTARÍA - LUIS FELIPE SEPÚLVEDA PONCE",
  prefix: "DON"
},
{
  num: "NOVENA",
  name: "9A NOTARÍA - HENRIETTE LARRÈRE RAVANAL (INTERINA)",
  commune: "VALPARAÍSO",
  displayName: "NOVENA NOTARÍA DE VALPARAÍSO, DE DOÑA 9A NOTARÍA - HENRIETTE LARRÈRE RAVANAL (INTERINA)",
  prefix: "DOÑA"
},
{
  num: "DÉCIMA",
  name: "10A NOTARÍA VALPARAISO ASIENTO JUAN FERNÁNDEZ - MARCELO PINTO AGUIRRE (INTERINO)",
  commune: "JUAN FERNÁNDEZ",
  displayName: "DÉCIMA NOTARÍA DE JUAN FERNÁNDEZ, DE DON 10A NOTARÍA VALPARAISO ASIENTO JUAN FERNÁNDEZ - MARCELO PINTO AGUIRRE (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "SECRETARIO, NOTARÍA, CONSERVADOR Y RECEPTOR - DANIEL VALENZUELA CASTILLO",
  commune: "ISLA DE PASCUA",
  displayName: "NOTARÍA NOTARÍA DE ISLA DE PASCUA, DE DON SECRETARIO, NOTARÍA, CONSERVADOR Y RECEPTOR - DANIEL VALENZUELA CASTILLO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO DE VIÑA DEL MAR - LUIS ENRIQUE FISCHER YAVAR",
  commune: "VIÑA DEL MAR",
  displayName: "NOTARÍA NOTARÍA DE VIÑA DEL MAR, DE DON CONSERVADOR Y ARCHIVERO DE VIÑA DEL MAR - LUIS ENRIQUE FISCHER YAVAR",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - RAÚL FARREN PAREDES",
  commune: "VIÑA DEL MAR",
  displayName: "PRIMERA NOTARÍA DE VIÑA DEL MAR, DE DON 1A NOTARÍA - RAÚL FARREN PAREDES",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - FRANCISCO JAVIER FUENZALIDA RODRÍGUEZ",
  commune: "VIÑA DEL MAR",
  displayName: "SEGUNDA NOTARÍA DE VIÑA DEL MAR, DE DON 2A NOTARÍA - FRANCISCO JAVIER FUENZALIDA RODRÍGUEZ",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - ELIANA GERVASIO ZAMUDIO",
  commune: "VIÑA DEL MAR",
  displayName: "TERCERA NOTARÍA DE VIÑA DEL MAR, DE DOÑA 3A NOTARÍA - ELIANA GERVASIO ZAMUDIO",
  prefix: "DOÑA"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - PAOLA DEBORAH STACK LARA",
  commune: "VIÑA DEL MAR",
  displayName: "CUARTA NOTARÍA DE VIÑA DEL MAR, DE DON 4A NOTARÍA - PAOLA DEBORAH STACK LARA",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - CECILIA GÁLVEZ PINO",
  commune: "VIÑA DEL MAR",
  displayName: "QUINTA NOTARÍA DE VIÑA DEL MAR, DE DON 5A NOTARÍA - CECILIA GÁLVEZ PINO",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA VIÑA DEL MAR ASIENTO CONCÓN - RODRIGO VILA CERVERA",
  commune: "CONCÓN",
  displayName: "SEXTA NOTARÍA DE CONCÓN, DE DON 6A NOTARÍA VIÑA DEL MAR ASIENTO CONCÓN - RODRIGO VILA CERVERA",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA - ORLANDO CERDA SILVA",
  commune: "VIÑA DEL MAR",
  displayName: "SÉPTIMA NOTARÍA DE VIÑA DEL MAR, DE DON 7A NOTARÍA - ORLANDO CERDA SILVA",
  prefix: "DON"
},
{
  num: "OCTAVA",
  name: "8A NOTARÍA ASTO REÑACA - MARCOS DÍAZ LEÓN",
  commune: "REÑACA",
  displayName: "OCTAVA NOTARÍA DE REÑACA, DE DON 8A NOTARÍA ASTO REÑACA - MARCOS DÍAZ LEÓN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE CONCÓN - CARLOS ALEJANDRO SWETT MUÑOZ",
  commune: "CONCON",
  displayName: "NOTARÍA NOTARÍA DE CONCON, DE DON CONSERVADOR DE CONCÓN - CARLOS ALEJANDRO SWETT MUÑOZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y COMERCIO - JOSÉ MANUEL RODRÍGUEZ QUIROS",
  commune: "QUILPUÉ",
  displayName: "NOTARÍA NOTARÍA DE QUILPUÉ, DE DON CONSERVADOR DE BIENES RAÍCES Y COMERCIO - JOSÉ MANUEL RODRÍGUEZ QUIROS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - JORGE ACUÑA PÉREZ",
  commune: "QUILPUÉ",
  displayName: "PRIMERA NOTARÍA DE QUILPUÉ, DE DON 1A NOTARÍA - JORGE ACUÑA PÉREZ",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - RICARDO HUMBERTO ROJAS PUGA (INTERINO)",
  commune: "QUILPUÉ",
  displayName: "SEGUNDA NOTARÍA DE QUILPUÉ, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - RICARDO HUMBERTO ROJAS PUGA (INTERINO)",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - CRISTIÁN VILLALOBOS PELLEGRINI",
  commune: "QUILPUÉ",
  displayName: "TERCERA NOTARÍA DE QUILPUÉ, DE DON 3A NOTARÍA - CRISTIÁN VILLALOBOS PELLEGRINI",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES - PATRICIA PÉREZ GOLDBERG",
  commune: "VILLA ALEMANA",
  displayName: "NOTARÍA NOTARÍA DE VILLA ALEMANA, DE DON CONSERVADOR DE BIENES RAÍCES - PATRICIA PÉREZ GOLDBERG",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - GLORIA ISABEL ORDÓÑEZ CORTÉS",
  commune: "",
  displayName: "PRIMERA NOTARÍA DE , DE DON 1A NOTARÍA - GLORIA ISABEL ORDÓÑEZ CORTÉS",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - PAULINA SOTOMAYOR GRAEPP",
  commune: "VILLA ALEMANA",
  displayName: "SEGUNDA NOTARÍA DE VILLA ALEMANA, DE DON 2A NOTARÍA - PAULINA SOTOMAYOR GRAEPP",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAICES - MAURICIO ROJAS ESCUDERO",
  commune: "CASABLANCA",
  displayName: "NOTARÍA NOTARÍA DE CASABLANCA, DE DON CONSERVADOR DE BIENES RAICES - MAURICIO ROJAS ESCUDERO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ALVARO FRANCISCO ESTRADA ALVARADO",
  commune: "CASABLANCA",
  displayName: "PRIMERA NOTARÍA DE CASABLANCA, DE DON 1A NOTARÍA - ALVARO FRANCISCO ESTRADA ALVARADO",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA CASABLANCA CON ASIENTO CURACAVÍ - DANIELA MUNIZAGA PÉNDOLA",
  commune: "CURACAVI",
  displayName: "SEGUNDA NOTARÍA DE CURACAVI, DE DON 2A NOTARÍA CASABLANCA CON ASIENTO CURACAVÍ - DANIELA MUNIZAGA PÉNDOLA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARIA Y CONSERVADOR DE BIENES RAÍCES DE ALGARROBO Y EL QUISCO - MARIO ALFONSO BARRÍA GALLEGOS",
  commune: "EL QUISCO",
  displayName: "TERCERA NOTARÍA DE EL QUISCO, DE DON 3A NOTARIA Y CONSERVADOR DE BIENES RAÍCES DE ALGARROBO Y EL QUISCO - MARIO ALFONSO BARRÍA GALLEGOS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES - RICARDO NAVARRO BELTRÁN",
  commune: "QUILLOTA",
  displayName: "NOTARÍA NOTARÍA DE QUILLOTA, DE DON CONSERVADOR DE BIENES RAÍCES - RICARDO NAVARRO BELTRÁN",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - JULIO ABUYERES JADUE",
  commune: "QUILLOTA",
  displayName: "PRIMERA NOTARÍA DE QUILLOTA, DE DON 1A NOTARÍA - JULIO ABUYERES JADUE",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - HUGO PATRICIO MONROY FOIX",
  commune: "QUILLOTA",
  displayName: "SEGUNDA NOTARÍA DE QUILLOTA, DE DON 2A NOTARÍA - HUGO PATRICIO MONROY FOIX",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONVERVADOR DE BIENES RAICES - MARCELO RAZÓN SANCHEZ",
  commune: "QUINTERO",
  displayName: "NOTARÍA NOTARÍA DE QUINTERO, DE DON CONVERVADOR DE BIENES RAICES - MARCELO RAZÓN SANCHEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "1O NOTARÍA - GUSTAVO EDUARDO JEANNERET MARTÍNEZ",
  commune: "QUINTERO",
  displayName: "NOTARÍA NOTARÍA DE QUINTERO, DE DON 1O NOTARÍA - GUSTAVO EDUARDO JEANNERET MARTÍNEZ",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARIA DE QUINTERO CON ASTO EN PUCHUNCAVÍ - CRISTIAN GARCÍA MECHSNER",
  commune: "PUCHUNCAVÍ",
  displayName: "SEGUNDA NOTARÍA DE PUCHUNCAVÍ, DE DON 2A NOTARIA DE QUINTERO CON ASTO EN PUCHUNCAVÍ - CRISTIAN GARCÍA MECHSNER",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAICES - CARMEN ESCOBILLANA SURHOFF",
  commune: "LA CALERA",
  displayName: "NOTARÍA NOTARÍA DE LA CALERA, DE DOÑA CONSERVADOR DE BIENES RAICES - CARMEN ESCOBILLANA SURHOFF",
  prefix: "DOÑA"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA QUILLOTA ASIENTO LA CALERA - LIDIA MARÍA CHAHUAN ISSA",
  commune: "LA CALERA",
  displayName: "PRIMERA NOTARÍA DE LA CALERA, DE DOÑA 1A NOTARÍA QUILLOTA ASIENTO LA CALERA - LIDIA MARÍA CHAHUAN ISSA",
  prefix: "DOÑA"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA DE CALERA ASTO HIJUELAS",
  commune: "",
  displayName: "SEGUNDA NOTARÍA DE , DE DON 2A NOTARÍA DE CALERA ASTO HIJUELAS",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA DE CALERA ASTO NOGALES",
  commune: "",
  displayName: "TERCERA NOTARÍA DE , DE DON 3A NOTARÍA DE CALERA ASTO NOGALES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES - LUIS PATRICIO OLATE MELO",
  commune: "LIMACHE",
  displayName: "NOTARÍA NOTARÍA DE LIMACHE, DE DON CONSERVADOR DE BIENES RAÍCES - LUIS PATRICIO OLATE MELO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - DAVID FERNANDO DEL FIERRO CIFUENTES",
  commune: "LIMACHE",
  displayName: "PRIMERA NOTARÍA DE LIMACHE, DE DON 1A NOTARÍA - DAVID FERNANDO DEL FIERRO CIFUENTES",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA LIMACHE ASIENTO OLMUÉ - JUAN PABLO ESPINOSA SCHIAPPACASSE",
  commune: "OLMUÉ",
  displayName: "SEGUNDA NOTARÍA DE OLMUÉ, DE DON 2A NOTARÍA LIMACHE ASIENTO OLMUÉ - JUAN PABLO ESPINOSA SCHIAPPACASSE",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES - ALINA MORALES TORTORA",
  commune: "LALIGUA",
  displayName: "NOTARÍA NOTARÍA DE LALIGUA, DE DON CONSERVADOR DE BIENES RAÍCES - ALINA MORALES TORTORA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ALEJANDRO PATRICIO GÓMEZ CORTÉS",
  commune: "LA LIGUA",
  displayName: "PRIMERA NOTARÍA DE LA LIGUA, DE DON 1A NOTARÍA - ALEJANDRO PATRICIO GÓMEZ CORTÉS",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARIA LA LIGUA ASTO CABILDO - JOSÉ ANTONIO LOPEZ VARGAS (INTERINO)",
  commune: "CABILDO, VALPARAÍSO",
  displayName: "SEGUNDA NOTARÍA DE CABILDO, VALPARAÍSO, DE DON 2A NOTARIA LA LIGUA ASTO CABILDO - JOSÉ ANTONIO LOPEZ VARGAS (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - ALEJANDRO HAUPT OSSA",
  commune: "PETORCA",
  displayName: "NOTARÍA NOTARÍA DE PETORCA, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - ALEJANDRO HAUPT OSSA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO - JORGE BARRIENTOS DÍAZ",
  commune: "LOS ANDES",
  displayName: "NOTARÍA NOTARÍA DE LOS ANDES, DE DON CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO - JORGE BARRIENTOS DÍAZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - MARTA RIVAS SCHULZ",
  commune: "LOS ANDES",
  displayName: "PRIMERA NOTARÍA DE LOS ANDES, DE DON 1A NOTARÍA - MARTA RIVAS SCHULZ",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - MAX ORDOÑEZ URBINA",
  commune: "LOS ANDES",
  displayName: "SEGUNDA NOTARÍA DE LOS ANDES, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - MAX ORDOÑEZ URBINA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA ASTO SAN ESTEBAN - CARLOS CRISTÓBAL AYLWIN DOMINGO",
  commune: "LOC. 4-A PORTAL SAN ESTEBAN, SAN ESTEBAN",
  displayName: "TERCERA NOTARÍA DE LOC. 4-A PORTAL SAN ESTEBAN, SAN ESTEBAN, DE DON 3A NOTARÍA ASTO SAN ESTEBAN - CARLOS CRISTÓBAL AYLWIN DOMINGO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y COMERCIO - ITALO VANI SILVA",
  commune: "SAN FELIPE",
  displayName: "NOTARÍA NOTARÍA DE SAN FELIPE, DE DON CONSERVADOR DE BIENES RAÍCES Y COMERCIO - ITALO VANI SILVA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - JAIME POLLONI CONTARDO",
  commune: "SAN FELIPE",
  displayName: "PRIMERA NOTARÍA DE SAN FELIPE, DE DON 1A NOTARÍA - JAIME POLLONI CONTARDO",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - ALEX PÉREZ DE TUDELA VEGA",
  commune: "SAN FELIPE",
  displayName: "SEGUNDA NOTARÍA DE SAN FELIPE, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - ALEX PÉREZ DE TUDELA VEGA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA SAN FELIPE ASIENTO LLAYLLAY Y CONSERVADOR DE BIENES RAÍCES - FERNANDO LASO CORDERO",
  commune: "LLAY LLAY",
  displayName: "NOTARÍA NOTARÍA DE LLAY LLAY, DE DON NOTARÍA SAN FELIPE ASIENTO LLAYLLAY Y CONSERVADOR DE BIENES RAÍCES - FERNANDO LASO CORDERO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - CRISTINA E. LOLAS CHABAN",
  commune: "PUTAENDO",
  displayName: "NOTARÍA NOTARÍA DE PUTAENDO, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - CRISTINA E. LOLAS CHABAN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO - BORIS OSNOVIKOFF ROMERO",
  commune: "LLOLLEO",
  displayName: "NOTARÍA NOTARÍA DE LLOLLEO, DE DON CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO - BORIS OSNOVIKOFF ROMERO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA Y CONSERVADOR DE MINAS - XIMENA RICCI DÍAZ",
  commune: "SAN ANTONIO",
  displayName: "PRIMERA NOTARÍA DE SAN ANTONIO, DE DON 1A NOTARÍA Y CONSERVADOR DE MINAS - XIMENA RICCI DÍAZ",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - MATIAS LE-ROUX PERALTA (INTERINO)",
  commune: "SAN ANTONIO",
  displayName: "SEGUNDA NOTARÍA DE SAN ANTONIO, DE DON 2A NOTARÍA - MATIAS LE-ROUX PERALTA (INTERINO)",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA SAN ANTONIO CON ASTO CARTAGENA - FERNANDO PIÑA RODRÍGUEZ (INTERINO)",
  commune: "CARTAGENA",
  displayName: "TERCERA NOTARÍA DE CARTAGENA, DE DON 3A NOTARÍA SAN ANTONIO CON ASTO CARTAGENA - FERNANDO PIÑA RODRÍGUEZ (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MAURICIO ASTUDILLO PIZARRO",
  commune: "RANCAGUA",
  displayName: "NOTARÍA NOTARÍA DE RANCAGUA, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MAURICIO ASTUDILLO PIZARRO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - GERARDO CARVALLO CASTILLO",
  commune: "RANCAGUA",
  displayName: "PRIMERA NOTARÍA DE RANCAGUA, DE DON 1A NOTARÍA - GERARDO CARVALLO CASTILLO",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - JORGE RODRIGO SCHWENKE ZÚÑIGA",
  commune: "RANCAGUA",
  displayName: "SEGUNDA NOTARÍA DE RANCAGUA, DE DON 2A NOTARÍA - JORGE RODRIGO SCHWENKE ZÚÑIGA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - MIGUEL CHACÓN ZEBALLOS (INTERINO)",
  commune: "RANCAGUA",
  displayName: "TERCERA NOTARÍA DE RANCAGUA, DE DON 3A NOTARÍA - MIGUEL CHACÓN ZEBALLOS (INTERINO)",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA RANCAGUA ASIENTO GRANEROS - GUILLERMO PÉREZ DÍAZ",
  commune: "GRANEROS",
  displayName: "CUARTA NOTARÍA DE GRANEROS, DE DON 4A NOTARÍA RANCAGUA ASIENTO GRANEROS - GUILLERMO PÉREZ DÍAZ",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - CECILIA GÁLVEZ PINO",
  commune: "RANCAGUA",
  displayName: "QUINTA NOTARÍA DE RANCAGUA, DE DON 5A NOTARÍA - CECILIA GÁLVEZ PINO",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA RANCAGUA ASIENTO MACHALÍ - CARLA SILVA ACHARÁN",
  commune: "MACHALÍ",
  displayName: "SEXTA NOTARÍA DE MACHALÍ, DE DOÑA 6A NOTARÍA RANCAGUA ASIENTO MACHALÍ - CARLA SILVA ACHARÁN",
  prefix: "DOÑA"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA RANCAGUA - RODRIGO JAVIER DÍAZ SUÁREZ",
  commune: "RANCAGUA",
  displayName: "SÉPTIMA NOTARÍA DE RANCAGUA, DE DON 7A NOTARÍA RANCAGUA - RODRIGO JAVIER DÍAZ SUÁREZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE GRANEROS - JUAN ROBERTO PEÑA URRA",
  commune: "GRANEROS",
  displayName: "NOTARÍA NOTARÍA DE GRANEROS, DE DON CONSERVADOR DE GRANEROS - JUAN ROBERTO PEÑA URRA",
  prefix: "DON"
},
{
  num: "OCTAVA",
  name: "8A NOTARÍA RANCAGUA ASTO DOÑIHUE, CONSERVADOR BS. RS. DOÑIHUE - LUISA PAMELA MEDINA SCHULZ",
  commune: "DOÑIHUE",
  displayName: "OCTAVA NOTARÍA DE DOÑIHUE, DE DON 8A NOTARÍA RANCAGUA ASTO DOÑIHUE, CONSERVADOR BS. RS. DOÑIHUE - LUISA PAMELA MEDINA SCHULZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUÁN RAÚL CRISTI LEÓN",
  commune: "RENGO",
  displayName: "NOTARÍA NOTARÍA DE RENGO, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUÁN RAÚL CRISTI LEÓN",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ANDRÉS MAURICIO FALCÓN VALENCIA",
  commune: "RENGO",
  displayName: "PRIMERA NOTARÍA DE RENGO, DE DON 1A NOTARÍA - ANDRÉS MAURICIO FALCÓN VALENCIA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - PAULINA VALENZUELA VALDÉS",
  commune: "RENGO",
  displayName: "SEGUNDA NOTARÍA DE RENGO, DE DON 2A NOTARÍA - PAULINA VALENZUELA VALDÉS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, ARCHIVERO JUDICIAL - JUAN ANGEL GONZALEZ PÉREZ",
  commune: "SAN VICENTE T.T.",
  displayName: "NOTARÍA NOTARÍA DE SAN VICENTE T.T., DE DON CONSERVADOR DE BIENES RAÍCES, ARCHIVERO JUDICIAL - JUAN ANGEL GONZALEZ PÉREZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA Y CONSERVADOR DE MINAS - GONZALO ANDRÉS CAMIRUAGA PIZARRO",
  commune: "SAN VICENTE T.T.",
  displayName: "PRIMERA NOTARÍA DE SAN VICENTE T.T., DE DON 1A NOTARÍA Y CONSERVADOR DE MINAS - GONZALO ANDRÉS CAMIRUAGA PIZARRO",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - IVÁN GARCÍA ASTABURUAGA (INTERINO)",
  commune: "SAN VICENTE T.T.",
  displayName: "SEGUNDA NOTARÍA DE SAN VICENTE T.T., DE DON 2A NOTARÍA - IVÁN GARCÍA ASTABURUAGA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - JORGE OSNOVIKOFF ROMERO",
  commune: "SAN FERNANDO",
  displayName: "NOTARÍA NOTARÍA DE SAN FERNANDO, DE DON CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - JORGE OSNOVIKOFF ROMERO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ALBERTO ÁNGEL ORTEGA JIRÓN",
  commune: "SAN FERNANDO",
  displayName: "PRIMERA NOTARÍA DE SAN FERNANDO, DE DON 1A NOTARÍA - ALBERTO ÁNGEL ORTEGA JIRÓN",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - CARLOS GUZMÁN BAIGORRIA",
  commune: "SAN FERNANDO",
  displayName: "SEGUNDA NOTARÍA DE SAN FERNANDO, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - CARLOS GUZMÁN BAIGORRIA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA SAN FERNANDO ASTO CHIMBARONGO - SEBASTIÁN CAMIRUAGA MARSHALL",
  commune: "LOC. 4, CHIMBARONGO",
  displayName: "TERCERA NOTARÍA DE LOC. 4, CHIMBARONGO, DE DON 3A NOTARÍA SAN FERNANDO ASTO CHIMBARONGO - SEBASTIÁN CAMIRUAGA MARSHALL",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - RICARDO ANTONIO LARENAS PEÑA (INTERINO)",
  commune: "2O PISO, SANTA CRUZ",
  displayName: "PRIMERA NOTARÍA DE 2O PISO, SANTA CRUZ, DE DON 1A NOTARÍA - RICARDO ANTONIO LARENAS PEÑA (INTERINO)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA, CONSERVADOR DE COMERCIO Y MINAS - JORGE GUILLERMO CARVALLO VELASCO",
  commune: "STA.CRUZ",
  displayName: "SEGUNDA NOTARÍA DE STA.CRUZ, DE DON 2A NOTARÍA, CONSERVADOR DE COMERCIO Y MINAS - JORGE GUILLERMO CARVALLO VELASCO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALEJANDRO PARDO KUSCHEL",
  commune: "PEUMO",
  displayName: "NOTARÍA NOTARÍA DE PEUMO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALEJANDRO PARDO KUSCHEL",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ISABEL MARGARITA CHADWICK VERGARA",
  commune: "PICHILEMU",
  displayName: "NOTARÍA NOTARÍA DE PICHILEMU, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ISABEL MARGARITA CHADWICK VERGARA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - SOLEDAD PÉREZ VEGA",
  commune: "PERALILLO",
  displayName: "NOTARÍA NOTARÍA DE PERALILLO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - SOLEDAD PÉREZ VEGA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARCELA MARLENE SAMMUR DEL RÍO",
  commune: "LITUECHE",
  displayName: "NOTARÍA NOTARÍA DE LITUECHE, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARCELA MARLENE SAMMUR DEL RÍO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - EDUARDO DEL CAMPO VIAL",
  commune: "3O PISO, CURICO",
  displayName: "NOTARÍA NOTARÍA DE 3O PISO, CURICO, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - EDUARDO DEL CAMPO VIAL",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - RODRIGO DOMÍNGUEZ JARA",
  commune: "CURICÓ",
  displayName: "PRIMERA NOTARÍA DE CURICÓ, DE DON 1A NOTARÍA - RODRIGO DOMÍNGUEZ JARA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - JORGE EDUARDO MESSEN CONCHA",
  commune: "CURICÓ",
  displayName: "SEGUNDA NOTARÍA DE CURICÓ, DE DON 2A NOTARÍA - JORGE EDUARDO MESSEN CONCHA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - HERNÁN URBANO FUENTES ACEVEDO",
  commune: "CURICÓ",
  displayName: "TERCERA NOTARÍA DE CURICÓ, DE DON 3A NOTARÍA - HERNÁN URBANO FUENTES ACEVEDO",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - CARLOS ANDRÉS ORTEGA ALUL",
  commune: "CURICÓ",
  displayName: "CUARTA NOTARÍA DE CURICÓ, DE DON 4A NOTARÍA - CARLOS ANDRÉS ORTEGA ALUL",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA CURICÓ ASIENTO COMUNA DE TENO - MONICA QUIROZ TRUJILLO",
  commune: "TENO",
  displayName: "QUINTA NOTARÍA DE TENO, DE DON 5A NOTARÍA CURICÓ ASIENTO COMUNA DE TENO - MONICA QUIROZ TRUJILLO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - VILMA BEATRIZ NAVARRO REYES",
  commune: "LICANTÉN",
  displayName: "NOTARÍA NOTARÍA DE LICANTÉN, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - VILMA BEATRIZ NAVARRO REYES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MIGUEL ABURTO CONTARDO",
  commune: "MOLINA",
  displayName: "NOTARÍA NOTARÍA DE MOLINA, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MIGUEL ABURTO CONTARDO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - BERNARD DEBEUF PONCE DE LEÓN",
  commune: "MOLINA",
  displayName: "PRIMERA NOTARÍA DE MOLINA, DE DON 1A NOTARÍA - BERNARD DEBEUF PONCE DE LEÓN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CAMILA JORQUEIRA MONARDEZ",
  commune: "TALCA",
  displayName: "NOTARÍA NOTARÍA DE TALCA, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CAMILA JORQUEIRA MONARDEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "ARCHIVERO JUDICIAL DE TALCA",
  commune: "TALCA",
  displayName: "NOTARÍA NOTARÍA DE TALCA, DE DON ARCHIVERO JUDICIAL DE TALCA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - MARÍA RAMIREZ FUENTES(INTERINO)",
  commune: "TALCA",
  displayName: "PRIMERA NOTARÍA DE TALCA, DE DOÑA 1A NOTARÍA - MARÍA RAMIREZ FUENTES(INTERINO)",
  prefix: "DOÑA"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - ENRIQUE ORTIZ SCHINDLER",
  commune: "TALCA",
  displayName: "SEGUNDA NOTARÍA DE TALCA, DE DON 2A NOTARÍA - ENRIQUE ORTIZ SCHINDLER",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - ANGELITA HORMAZÁBAL ALEGRÍA",
  commune: "TALCA",
  displayName: "TERCERA NOTARÍA DE TALCA, DE DON 3A NOTARÍA - ANGELITA HORMAZÁBAL ALEGRÍA",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - JAIME ANDRÉS SILVA SCIBERRAS",
  commune: "TALCA",
  displayName: "CUARTA NOTARÍA DE TALCA, DE DON 4A NOTARÍA - JAIME ANDRÉS SILVA SCIBERRAS",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - TEODORO DURÁN PALMA",
  commune: "TALCA",
  displayName: "QUINTA NOTARÍA DE TALCA, DE DON 5A NOTARÍA - TEODORO DURÁN PALMA",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA - GABRIEL GUERRERO GONZÁLEZ",
  commune: "TALCA",
  displayName: "SÉPTIMA NOTARÍA DE TALCA, DE DON 7A NOTARÍA - GABRIEL GUERRERO GONZÁLEZ",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA TALCA ASIENTO COMUNA DE SAN CLEMENTE - JUAN ENRIQUE JARA OPAZO (INTERINO)",
  commune: "SAN CLEMENTE",
  displayName: "SEXTA NOTARÍA DE SAN CLEMENTE, DE DON 6A NOTARÍA TALCA ASIENTO COMUNA DE SAN CLEMENTE - JUAN ENRIQUE JARA OPAZO (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES DE SAN CLEMENTE - JUAN CARLOS ARTUS MORALES",
  commune: "LOCAL 2016 AL 218, SAN CLEMENTE",
  displayName: "NOTARÍA NOTARÍA DE LOCAL 2016 AL 218, SAN CLEMENTE, DE DON CONSERVADOR DE BIENES RAÍCES DE SAN CLEMENTE - JUAN CARLOS ARTUS MORALES",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA TALCA ASIENTO EN MAULE, CONSERVADOR MAULE - PAULINA VALDERRAMA VALDÉS",
  commune: "MAULE",
  displayName: "SÉPTIMA NOTARÍA DE MAULE, DE DON 7A NOTARÍA TALCA ASIENTO EN MAULE, CONSERVADOR MAULE - PAULINA VALDERRAMA VALDÉS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - JORGE ANDRÉS ALLENDE GONZÁLEZ",
  commune: "CUREPTO",
  displayName: "NOTARÍA NOTARÍA DE CUREPTO, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - JORGE ANDRÉS ALLENDE GONZÁLEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARIA ANDREA VEGA FAÚNDEZ",
  commune: "CONSTITUCIÓN",
  displayName: "NOTARÍA NOTARÍA DE CONSTITUCIÓN, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARIA ANDREA VEGA FAÚNDEZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ALVARO MERA CORREA",
  commune: "CONSTITUCIÓN",
  displayName: "PRIMERA NOTARÍA DE CONSTITUCIÓN, DE DON 1A NOTARÍA - ALVARO MERA CORREA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA VERÓNICA MARTÍNEZ ABRAHAM",
  commune: "SAN JAVIER",
  displayName: "NOTARÍA NOTARÍA DE SAN JAVIER, DE DOÑA CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA VERÓNICA MARTÍNEZ ABRAHAM",
  prefix: "DOÑA"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - PAMELA CECILIA ASTORGA PÁEZ",
  commune: "SAN JAVIER",
  displayName: "PRIMERA NOTARÍA DE SAN JAVIER, DE DON 1A NOTARÍA - PAMELA CECILIA ASTORGA PÁEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO LINARES - FERNANDO ANDRÉS GOMILA LARSEN",
  commune: "LINARES",
  displayName: "NOTARÍA NOTARÍA DE LINARES, DE DON CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO LINARES - FERNANDO ANDRÉS GOMILA LARSEN",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - EDISON TRINCADO CÓRDOVA",
  commune: "LINARES",
  displayName: "PRIMERA NOTARÍA DE LINARES, DE DON 1A NOTARÍA - EDISON TRINCADO CÓRDOVA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - ANDRÉS CUADRA GONZÁLEZ DEL RIEGO",
  commune: "LINARES",
  displayName: "SEGUNDA NOTARÍA DE LINARES, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - ANDRÉS CUADRA GONZÁLEZ DEL RIEGO",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - LUIS GUILLERMO ALVAREZ DONOSO",
  commune: "LINARES",
  displayName: "TERCERA NOTARÍA DE LINARES, DE DON 3A NOTARÍA - LUIS GUILLERMO ALVAREZ DONOSO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA LINARES ASIENTO COMUNA LONGAVÍ Y CONSERVADOR DE BIENES RAÍCES - RICARDO ANDRÉS SÁNCHEZ VALDÉS",
  commune: "LONGAVÍ",
  displayName: "NOTARÍA NOTARÍA DE LONGAVÍ, DE DON NOTARÍA LINARES ASIENTO COMUNA LONGAVÍ Y CONSERVADOR DE BIENES RAÍCES - RICARDO ANDRÉS SÁNCHEZ VALDÉS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MATÍAS JORQUIERA SOTOMAYOR (INTERINO)",
  commune: "CAUQUENES",
  displayName: "NOTARÍA NOTARÍA DE CAUQUENES, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MATÍAS JORQUIERA SOTOMAYOR (INTERINO)",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - GLADYS HERNANDEZ MANZANO",
  commune: "PISO 1, CAUQUENES",
  displayName: "PRIMERA NOTARÍA DE PISO 1, CAUQUENES, DE DON 1A NOTARÍA - GLADYS HERNANDEZ MANZANO",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - IVONNE ELGUETA CANCINO (INTERINA)",
  commune: "CAUQUENES",
  displayName: "SEGUNDA NOTARÍA DE CAUQUENES, DE DON 2A NOTARÍA - IVONNE ELGUETA CANCINO (INTERINA)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - PAULA ESPERANZA NOVOA VALDÉS (INTERINO)",
  commune: "CHANCO",
  displayName: "NOTARÍA NOTARÍA DE CHANCO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - PAULA ESPERANZA NOVOA VALDÉS (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JORGE ENRIQUE FIGUEROA HERRERA",
  commune: "2O PISO , PARRAL",
  displayName: "NOTARÍA NOTARÍA DE 2O PISO , PARRAL, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JORGE ENRIQUE FIGUEROA HERRERA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - OMAR ANDRÉS PEREZ AGUILERA",
  commune: "PARRAL",
  displayName: "PRIMERA NOTARÍA DE PARRAL, DE DON 1A NOTARÍA - OMAR ANDRÉS PEREZ AGUILERA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA PARRAL ASIENTO RETIRO - HERNÁN OSVALDO NESBET JARAMILLO",
  commune: "",
  displayName: "SEGUNDA NOTARÍA DE , DE DON 2A NOTARÍA PARRAL ASIENTO RETIRO - HERNÁN OSVALDO NESBET JARAMILLO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL DE CHILLÁN - YAMIL ABRAHAM NAJLE ALÉE",
  commune: "LOCAL 3 INTERIOR , CHILLÁN",
  displayName: "NOTARÍA NOTARÍA DE LOCAL 3 INTERIOR , CHILLÁN, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL DE CHILLÁN - YAMIL ABRAHAM NAJLE ALÉE",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - LUIS EDUARDO SOLAR BACH",
  commune: "CHILLÁN",
  displayName: "PRIMERA NOTARÍA DE CHILLÁN, DE DON 1A NOTARÍA - LUIS EDUARDO SOLAR BACH",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - JOAQUÍN TEJOS HENRÍQUEZ",
  commune: "CHILLÁN",
  displayName: "SEGUNDA NOTARÍA DE CHILLÁN, DE DON 2A NOTARÍA - JOAQUÍN TEJOS HENRÍQUEZ",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - JUAN ARMANDO BUSTOS BONNIARD",
  commune: "CHILLÁN",
  displayName: "TERCERA NOTARÍA DE CHILLÁN, DE DON 3A NOTARÍA - JUAN ARMANDO BUSTOS BONNIARD",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - LUIS ÁLVAREZ DÍAZ",
  commune: "CHILLÁN",
  displayName: "CUARTA NOTARÍA DE CHILLÁN, DE DON 4A NOTARÍA - LUIS ÁLVAREZ DÍAZ",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - CÉSAR ANDRÉS SUÁREZ SÁNCHEZ",
  commune: "CHILLÁN",
  displayName: "QUINTA NOTARÍA DE CHILLÁN, DE DON 5A NOTARÍA - CÉSAR ANDRÉS SUÁREZ SÁNCHEZ",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA - JANINA LORENA RODRÍGUEZ CORTÉS",
  commune: "CHILLÁN",
  displayName: "SEXTA NOTARÍA DE CHILLÁN, DE DON 6A NOTARÍA - JANINA LORENA RODRÍGUEZ CORTÉS",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA Y CONSERVADOR DE BS. RS. ASTO PINTO - XIMENA ANDREA ULSEN RIVAS",
  commune: "LOCAL 231, PINTO",
  displayName: "SÉPTIMA NOTARÍA DE LOCAL 231, PINTO, DE DON 7A NOTARÍA Y CONSERVADOR DE BS. RS. ASTO PINTO - XIMENA ANDREA ULSEN RIVAS",
  prefix: "DON"
},
{
  num: "OCTAVA",
  name: "8A NOTARÍA Y CONSERVADOR DE BS. RS. ASTO COIHUECO - HECTOR ANDRÉS CARRASCO SANHUEZA",
  commune: "COIHUECO",
  displayName: "OCTAVA NOTARÍA DE COIHUECO, DE DON 8A NOTARÍA Y CONSERVADOR DE BS. RS. ASTO COIHUECO - HECTOR ANDRÉS CARRASCO SANHUEZA",
  prefix: "DON"
},
{
  num: "NOVENA",
  name: "9A NOTARÍA Y CONSERVADOR DE BS. RS. ASTO CHILLÁN VIEJO - GERARDO CORTÉS GASSUI",
  commune: "CHILLÁN VIEJO",
  displayName: "NOVENA NOTARÍA DE CHILLÁN VIEJO, DE DON 9A NOTARÍA Y CONSERVADOR DE BS. RS. ASTO CHILLÁN VIEJO - GERARDO CORTÉS GASSUI",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CÉSAR FUENTES VENEGAS",
  commune: "SAN CARLOS",
  displayName: "NOTARÍA NOTARÍA DE SAN CARLOS, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CÉSAR FUENTES VENEGAS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - RODRIGO IRRIBARRA SALAZAR (INTERINO)",
  commune: "SAN CARLOS",
  displayName: "PRIMERA NOTARÍA DE SAN CARLOS, DE DON 1A NOTARÍA - RODRIGO IRRIBARRA SALAZAR (INTERINO)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA ASIENTO COMUNA DE ÑIQUÉN - JONATHAN ANDRÉS FUENTES PARADA",
  commune: "SAN GREGORIO, ÑIQUÉN",
  displayName: "SEGUNDA NOTARÍA DE SAN GREGORIO, ÑIQUÉN, DE DON 2A NOTARÍA ASIENTO COMUNA DE ÑIQUÉN - JONATHAN ANDRÉS FUENTES PARADA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARCELO RIESCO VEGA",
  commune: "YUNGAY",
  displayName: "NOTARÍA NOTARÍA DE YUNGAY, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARCELO RIESCO VEGA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - GUILLERMO ROSSEMBLATT PRADENAS",
  commune: "YUNGAY",
  displayName: "PRIMERA NOTARÍA DE YUNGAY, DE DON 1A NOTARÍA - GUILLERMO ROSSEMBLATT PRADENAS",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA YUNGAY ASIENTO COMUNA DE TUCAPEL - FRANCISCO JAVIER LARENAS VEGA",
  commune: "HUÉPIL",
  displayName: "SEGUNDA NOTARÍA DE HUÉPIL, DE DON 2A NOTARÍA YUNGAY ASIENTO COMUNA DE TUCAPEL - FRANCISCO JAVIER LARENAS VEGA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR Y ARCHIVERO JUDICIAL - OSCAR JORGE PAVÉS MORALES",
  commune: "BULNESS",
  displayName: "NOTARÍA NOTARÍA DE BULNESS, DE DON CONSERVADOR Y ARCHIVERO JUDICIAL - OSCAR JORGE PAVÉS MORALES",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - GABRIELA MARÍA GUTIÉRREZ VALVERDE (INTERINO)",
  commune: "BULNES",
  displayName: "PRIMERA NOTARÍA DE BULNES, DE DOÑA 1A NOTARÍA - GABRIELA MARÍA GUTIÉRREZ VALVERDE (INTERINO)",
  prefix: "DOÑA"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA BULNES ASTO QUILLÓN - JOAQUIN IGNACIO TRONCOSO PEREIRA (INTERINO)",
  commune: "QUILLÓN",
  displayName: "SEGUNDA NOTARÍA DE QUILLÓN, DE DON 2A NOTARÍA BULNES ASTO QUILLÓN - JOAQUIN IGNACIO TRONCOSO PEREIRA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CONSTANZA ANDREA QUINTANA JARAMILLO",
  commune: "COELEMU",
  displayName: "NOTARÍA NOTARÍA DE COELEMU, DE DOÑA NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CONSTANZA ANDREA QUINTANA JARAMILLO",
  prefix: "DOÑA"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - RAÚL LEIVA URIBE-ECHEVERRÍA",
  commune: "QUIRIHUE",
  displayName: "NOTARÍA NOTARÍA DE QUIRIHUE, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - RAÚL LEIVA URIBE-ECHEVERRÍA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - JORGE CONDEZA VACCARO",
  commune: "PISO 2°, CONCEPCIÓN",
  displayName: "NOTARÍA NOTARÍA DE PISO 2°, CONCEPCIÓN, DE DON CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - JORGE CONDEZA VACCARO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA Y CONSERVADOR DE MINAS - RICARDO SALGADO SEPULVEDA",
  commune: "CONCEPCIÓN",
  displayName: "PRIMERA NOTARÍA DE CONCEPCIÓN, DE DON 1A NOTARÍA Y CONSERVADOR DE MINAS - RICARDO SALGADO SEPULVEDA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - PEDRO HIDALGO SARZOSA (INTERINO)",
  commune: "CONCEPCIÓN",
  displayName: "SEGUNDA NOTARÍA DE CONCEPCIÓN, DE DON 2A NOTARÍA - PEDRO HIDALGO SARZOSA (INTERINO)",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - JUAN ESPINOSA BANCALARI",
  commune: "CONCEPCIÓN",
  displayName: "TERCERA NOTARÍA DE CONCEPCIÓN, DE DON 3A NOTARÍA - JUAN ESPINOSA BANCALARI",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - HERACLIO ROJAS VERGARA",
  commune: "CONCEP",
  displayName: "CUARTA NOTARÍA DE CONCEP, DE DON 4A NOTARÍA - HERACLIO ROJAS VERGARA",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - MAURO FABIÁN AROCA GUERRERO",
  commune: "CONCEPCIÓN",
  displayName: "QUINTA NOTARÍA DE CONCEPCIÓN, DE DON 5A NOTARÍA - MAURO FABIÁN AROCA GUERRERO",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA - MARIO PATRICIO ABURTO CONTARDO",
  commune: "CONCEPCIÓN",
  displayName: "SEXTA NOTARÍA DE CONCEPCIÓN, DE DON 6A NOTARÍA - MARIO PATRICIO ABURTO CONTARDO",
  prefix: "DON"
},
{
  num: "SÉPTIMA",
  name: "7A NOTARÍA - RAMÓN GARCÍA CARRASCO",
  commune: "CONCEPCIÓN",
  displayName: "SÉPTIMA NOTARÍA DE CONCEPCIÓN, DE DON 7A NOTARÍA - RAMÓN GARCÍA CARRASCO",
  prefix: "DON"
},
{
  num: "OCTAVA",
  name: "8A NOTARÍA ASIENTO COMUNA CHIGUAYANTE - RODRIGO WUNKHAUS RIGART (INTERINO)",
  commune: "CHIGUAYANTE",
  displayName: "OCTAVA NOTARÍA DE CHIGUAYANTE, DE DON 8A NOTARÍA ASIENTO COMUNA CHIGUAYANTE - RODRIGO WUNKHAUS RIGART (INTERINO)",
  prefix: "DON"
},
{
  num: "NOVENA",
  name: "9A NOTARÍA ASIENTO COMUNA SAN PEDRO DE LA PAZ - RODRIGO ROJAS CASTILLO",
  commune: "SAN PEDRO DE LA PAZ",
  displayName: "NOVENA NOTARÍA DE SAN PEDRO DE LA PAZ, DE DON 9A NOTARÍA ASIENTO COMUNA SAN PEDRO DE LA PAZ - RODRIGO ROJAS CASTILLO",
  prefix: "DON"
},
{
  num: "DÉCIMA",
  name: "10A NOTARÍA ASIENCO COMUNA DE PENCO - ALEJANDRO ABUTER GAME",
  commune: "PENCO",
  displayName: "DÉCIMA NOTARÍA DE PENCO, DE DON 10A NOTARÍA ASIENCO COMUNA DE PENCO - ALEJANDRO ABUTER GAME",
  prefix: "DON"
},
{
  num: "UNDÉCIMA",
  name: "11A NOTARÍA ASIENCO COMUNA DE PENCO - RENÉ MARCELO ARRIAGADA BASAUR",
  commune: "CONCEPCIÓN",
  displayName: "UNDÉCIMA NOTARÍA DE CONCEPCIÓN, DE DON 11A NOTARÍA ASIENCO COMUNA DE PENCO - RENÉ MARCELO ARRIAGADA BASAUR",
  prefix: "DON"
},
{
  num: "DUODÉCIMA",
  name: "12A NOTARÍA - JUAN EDUARDO AVELLO SAN MARTÍN",
  commune: "CONCEPCIÓN",
  displayName: "DUODÉCIMA NOTARÍA DE CONCEPCIÓN, DE DON 12A NOTARÍA - JUAN EDUARDO AVELLO SAN MARTÍN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES - GUACOLDA AEDO ORMEÑO",
  commune: "CHIGUAYANTE",
  displayName: "NOTARÍA NOTARÍA DE CHIGUAYANTE, DE DON CONSERVADOR DE BIENES RAÍCES - GUACOLDA AEDO ORMEÑO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES - HECTOR SEPÚLVEDA QUINTANA",
  commune: "SAN PEDRO DE LA PAZ",
  displayName: "NOTARÍA NOTARÍA DE SAN PEDRO DE LA PAZ, DE DOÑA CONSERVADOR DE BIENES RAÍCES - HECTOR SEPÚLVEDA QUINTANA",
  prefix: "DOÑA"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y COMERCIO - SERGIO CONDEZA NEUBER",
  commune: "TALCAHUANO",
  displayName: "NOTARÍA NOTARÍA DE TALCAHUANO, DE DON CONSERVADOR DE BIENES RAÍCES Y COMERCIO - SERGIO CONDEZA NEUBER",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - OMAR RETAMAL BECERRA",
  commune: "TALCAHUANO",
  displayName: "PRIMERA NOTARÍA DE TALCAHUANO, DE DON 1A NOTARÍA - OMAR RETAMAL BECERRA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA Y CONSERVADOR DE MINAS - GASTÓN SANTIBÁÑEZ TORRES",
  commune: "TALCAHUANO",
  displayName: "SEGUNDA NOTARÍA DE TALCAHUANO, DE DON 2A NOTARÍA Y CONSERVADOR DE MINAS - GASTÓN SANTIBÁÑEZ TORRES",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA Y ARCHIVERO JUDICIAL - NÉSTOR ALEJANDRO AVILA URRUTIA",
  commune: "TALCAHUANO",
  displayName: "TERCERA NOTARÍA DE TALCAHUANO, DE DON 3A NOTARÍA Y ARCHIVERO JUDICIAL - NÉSTOR ALEJANDRO AVILA URRUTIA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE HUALPÉN - MARIANA CRISTINA ABUTER GAME",
  commune: "HUALPEN",
  displayName: "NOTARÍA NOTARÍA DE HUALPEN, DE DOÑA CONSERVADOR DE HUALPÉN - MARIANA CRISTINA ABUTER GAME",
  prefix: "DOÑA"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA TALCAHUANO ASIENTO COMUNA DE HUELPEN - VICTOR TOLEDO MACHUCHA (INTERINO)",
  commune: "",
  displayName: "CUARTA NOTARÍA DE , DE DON 4A NOTARÍA TALCAHUANO ASIENTO COMUNA DE HUELPEN - VICTOR TOLEDO MACHUCHA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CAROLINA FUENTEALBA MADRIAGA",
  commune: "TOMÉ",
  displayName: "NOTARÍA NOTARÍA DE TOMÉ, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CAROLINA FUENTEALBA MADRIAGA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA - GONZALO ESTEBAN MÍGUEZ NÚÑEZ",
  commune: "TOMÉ",
  displayName: "NOTARÍA NOTARÍA DE TOMÉ, DE DON NOTARÍA - GONZALO ESTEBAN MÍGUEZ NÚÑEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES, COMERCIO, MINAS Y ARCHIVERO JUDICIAL INTERINO - RICARDO JAVIER MOSCOSO CERDA (INTERINO)",
  commune: "P.1, COMUNA DE FLORIDA, PROVINCIA DE CONCEPCIÓN, REGIÓN DEL BIOBÍO",
  displayName: "NOTARÍA NOTARÍA DE P.1, COMUNA DE FLORIDA, PROVINCIA DE CONCEPCIÓN, REGIÓN DEL BIOBÍO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES, COMERCIO, MINAS Y ARCHIVERO JUDICIAL INTERINO - RICARDO JAVIER MOSCOSO CERDA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - MARIA ISABEL GONZÁLEZ BARRIENTOS",
  commune: "SANTA JUANA",
  displayName: "NOTARÍA NOTARÍA DE SANTA JUANA, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - MARIA ISABEL GONZÁLEZ BARRIENTOS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JOCELYN GISELA SANHUEZA CORTES (INTERINO)",
  commune: "LOTA BAJO",
  displayName: "NOTARÍA NOTARÍA DE LOTA BAJO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JOCELYN GISELA SANHUEZA CORTES (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ROBERTO JARA CANALES (INT-SUPLENTE)",
  commune: "CORONEL",
  displayName: "NOTARÍA NOTARÍA DE CORONEL, DE DOÑA CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ROBERTO JARA CANALES (INT-SUPLENTE)",
  prefix: "DOÑA"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - GONZALO CAMIRUAGA PIZARRO (INTERINO)",
  commune: "CORONEL",
  displayName: "PRIMERA NOTARÍA DE CORONEL, DE DON 1A NOTARÍA - GONZALO CAMIRUAGA PIZARRO (INTERINO)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - GONZALO ALI ARCAS (INTERINO)",
  commune: "CORONEL",
  displayName: "SEGUNDA NOTARÍA DE CORONEL, DE DON 2A NOTARÍA - GONZALO ALI ARCAS (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - DANIEL GARRETÓN RODRÍGUEZ",
  commune: "LOS ANGELES",
  displayName: "NOTARÍA NOTARÍA DE LOS ANGELES, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - DANIEL GARRETÓN RODRÍGUEZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - CRISTIAN FELIPE CAMILLA SANSOVAL",
  commune: "LOS ANGELES",
  displayName: "PRIMERA NOTARÍA DE LOS ANGELES, DE DON 1A NOTARÍA - CRISTIAN FELIPE CAMILLA SANSOVAL",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - RODRIGO ORLANDO CANTUARIAS COSTA",
  commune: "LOS ANGELES",
  displayName: "SEGUNDA NOTARÍA DE LOS ANGELES, DE DON 2A NOTARÍA - RODRIGO ORLANDO CANTUARIAS COSTA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - MARÍA ANTONIETA CARRILLO FLORES",
  commune: "LOS ANGELES",
  displayName: "TERCERA NOTARÍA DE LOS ANGELES, DE DOÑA 3A NOTARÍA - MARÍA ANTONIETA CARRILLO FLORES",
  prefix: "DOÑA"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - JUAN MAURICIO ARANEDA MEDINA",
  commune: "LOS ANGELES",
  displayName: "CUARTA NOTARÍA DE LOS ANGELES, DE DON 4A NOTARÍA - JUAN MAURICIO ARANEDA MEDINA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - PAMELA CRISTINA ORELLANA PATIÑO",
  commune: "SANTA BÁRBARA",
  displayName: "NOTARÍA NOTARÍA DE SANTA BÁRBARA, DE DOÑA NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - PAMELA CRISTINA ORELLANA PATIÑO",
  prefix: "DOÑA"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - JAIME CIFUENTES VILLAGRÁN",
  commune: "MULCHÉN",
  displayName: "NOTARÍA NOTARÍA DE MULCHÉN, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - JAIME CIFUENTES VILLAGRÁN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - RUTH VILLALOBOS GUTIERREZ",
  commune: "NACIMIENTO",
  displayName: "NOTARÍA NOTARÍA DE NACIMIENTO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - RUTH VILLALOBOS GUTIERREZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUAN ANTONIO PUGA LOZANO",
  commune: "LAJA",
  displayName: "NOTARÍA NOTARÍA DE LAJA, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUAN ANTONIO PUGA LOZANO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - ESTEFANIA ESTRADA RIVAS",
  commune: "YUMBEL",
  displayName: "NOTARÍA NOTARÍA DE YUMBEL, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - ESTEFANIA ESTRADA RIVAS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - SANDRA MARCELA SEPÚLVEDA MARTINEZ",
  commune: "CABRERO",
  displayName: "NOTARÍA NOTARÍA DE CABRERO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - SANDRA MARCELA SEPÚLVEDA MARTINEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARIA DE CABRERO - MIGUEL HUMBERTO RAMÍREZ ÁLVAREZ",
  commune: "CABRERO",
  displayName: "NOTARÍA NOTARÍA DE CABRERO, DE DON NOTARIA DE CABRERO - MIGUEL HUMBERTO RAMÍREZ ÁLVAREZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - DANIEL RIGOBERTO ÁLVAREZ SOZA",
  commune: "LEBU",
  displayName: "NOTARÍA NOTARÍA DE LEBU, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - DANIEL RIGOBERTO ÁLVAREZ SOZA",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA DE LEBU ASIENTO LOS ÁLAMOS",
  commune: "",
  displayName: "SEGUNDA NOTARÍA DE , DE DON 2A NOTARÍA DE LEBU ASIENTO LOS ÁLAMOS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ANFIÓN PODLECH ROMERO",
  commune: "ARAUCO",
  displayName: "NOTARÍA NOTARÍA DE ARAUCO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ANFIÓN PODLECH ROMERO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARIACRUZ GARRETÓN ROMERO (INTERINO)",
  commune: "CURANILAHUE",
  displayName: "NOTARÍA NOTARÍA DE CURANILAHUE, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARIACRUZ GARRETÓN ROMERO (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - GONZALO JESÚS MONTANÉ WENZEL",
  commune: "CAÑETE",
  displayName: "NOTARÍA NOTARÍA DE CAÑETE, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - GONZALO JESÚS MONTANÉ WENZEL",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - STEFAN MINCK TROMBERT (INTERINO)",
  commune: "ANGOL",
  displayName: "NOTARÍA NOTARÍA DE ANGOL, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - STEFAN MINCK TROMBERT (INTERINO)",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - CARLOS ALEJANDRO FUENTES CÁCERES",
  commune: "ANGOL",
  displayName: "PRIMERA NOTARÍA DE ANGOL, DE DON 1A NOTARÍA - CARLOS ALEJANDRO FUENTES CÁCERES",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - CHARLES ANDRÉS DE LA HARPE PALMA",
  commune: "ANGOL",
  displayName: "SEGUNDA NOTARÍA DE ANGOL, DE DON 2A NOTARÍA - CHARLES ANDRÉS DE LA HARPE PALMA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - HUGO ALBERTO MARÍN DÍAZ",
  commune: "COLLIPULLI",
  displayName: "NOTARÍA NOTARÍA DE COLLIPULLI, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - HUGO ALBERTO MARÍN DÍAZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ROBERTO COOPER AGUILERA",
  commune: "PURÉN",
  displayName: "NOTARÍA NOTARÍA DE PURÉN, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ROBERTO COOPER AGUILERA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES - YUSEF GERARDO HALES HOTT",
  commune: "TRAIGUÉN",
  displayName: "NOTARÍA NOTARÍA DE TRAIGUÉN, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES - YUSEF GERARDO HALES HOTT",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA ELENA PEZOA CONTRERAS",
  commune: "CURACAUTÍN",
  displayName: "NOTARÍA NOTARÍA DE CURACAUTÍN, DE DOÑA NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA ELENA PEZOA CONTRERAS",
  prefix: "DOÑA"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ÁLVARO ANTONIO SANTOS DÍAZ (INTERINO)",
  commune: "CURACAUTÍN",
  displayName: "PRIMERA NOTARÍA DE CURACAUTÍN, DE DON 1A NOTARÍA - ÁLVARO ANTONIO SANTOS DÍAZ (INTERINO)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA DE CURACAUTIN, ASIENTO LONQUIMAY, CONSERVADOR Y ARCHIVERO JUDICIAL - MARIANELA DEL CARMEN ESCOBAR MELO",
  commune: "LONQUIMAY",
  displayName: "SEGUNDA NOTARÍA DE LONQUIMAY, DE DON 2A NOTARÍA DE CURACAUTIN, ASIENTO LONQUIMAY, CONSERVADOR Y ARCHIVERO JUDICIAL - MARIANELA DEL CARMEN ESCOBAR MELO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALEX SEPÚLVEDA CABEZAS (INTERINO)",
  commune: "VICTORIA",
  displayName: "NOTARÍA NOTARÍA DE VICTORIA, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALEX SEPÚLVEDA CABEZAS (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "1° NOTARÍA - CESAR ENRIQUE PEIÑAN AILLAPÁN",
  commune: "VICTORIA",
  displayName: "NOTARÍA NOTARÍA DE VICTORIA, DE DON 1° NOTARÍA - CESAR ENRIQUE PEIÑAN AILLAPÁN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - HUMBERTO TORO MARTÍNEZ-CONDE",
  commune: "TEMUCO",
  displayName: "NOTARÍA NOTARÍA DE TEMUCO, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - HUMBERTO TORO MARTÍNEZ-CONDE",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "2O CONSERVADOR DE BIENES RAÍCES ASIENTO COMUNA DE TEMUCO - RODRIGO SEPÚLVEDA GÓMEZ",
  commune: "TEMUCO",
  displayName: "NOTARÍA NOTARÍA DE TEMUCO, DE DON 2O CONSERVADOR DE BIENES RAÍCES ASIENTO COMUNA DE TEMUCO - RODRIGO SEPÚLVEDA GÓMEZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ÁLVARO JAVIER VALDEBENITO SALGADO",
  commune: "TEMUCO",
  displayName: "PRIMERA NOTARÍA DE TEMUCO, DE DON 1A NOTARÍA - ÁLVARO JAVIER VALDEBENITO SALGADO",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - ESMIRNA VIDAL MORAGA",
  commune: "TEMUCO",
  displayName: "SEGUNDA NOTARÍA DE TEMUCO, DE DON 2A NOTARÍA - ESMIRNA VIDAL MORAGA",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - JUAN ANTONIO LOYOLA OPAZO",
  commune: "TEMUCO",
  displayName: "TERCERA NOTARÍA DE TEMUCO, DE DON 3A NOTARÍA - JUAN ANTONIO LOYOLA OPAZO",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - ELENA LEYTON CARVAJAL",
  commune: "TEMUCO",
  displayName: "CUARTA NOTARÍA DE TEMUCO, DE DON 4A NOTARÍA - ELENA LEYTON CARVAJAL",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - JORGE TADRES HALES",
  commune: "TEMUCO",
  displayName: "QUINTA NOTARÍA DE TEMUCO, DE DON 5A NOTARÍA - JORGE TADRES HALES",
  prefix: "DON"
},
{
  num: "NOVENA",
  name: "9A NOTARÍA - PAULA NICOLE FALCÓN CARTES",
  commune: "TEMUCO",
  displayName: "NOVENA NOTARÍA DE TEMUCO, DE DON 9A NOTARÍA - PAULA NICOLE FALCÓN CARTES",
  prefix: "DON"
},
{
  num: "SEXTA",
  name: "6A NOTARÍA TEMUCO ASIENTO COMUNA PADRE DE LAS CASAS - MATÍAS FRANCO BÖKE (INTERINO)",
  commune: "TEMUCO",
  displayName: "SEXTA NOTARÍA DE TEMUCO, DE DON 6A NOTARÍA TEMUCO ASIENTO COMUNA PADRE DE LAS CASAS - MATÍAS FRANCO BÖKE (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA TEMUCO ASTO VILCÚN CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CARLOS MARTÍNEZ ELGUETA",
  commune: "VILCÚN",
  displayName: "NOTARÍA NOTARÍA DE VILCÚN, DE DON NOTARÍA TEMUCO ASTO VILCÚN CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CARLOS MARTÍNEZ ELGUETA",
  prefix: "DON"
},
{
  num: "OCTAVA",
  name: "8A NOTARÍA TEMUCO ASIENTO COMUNA DE CUNCO, CONSERVADOR DE BIENES RAÍCES - CARLOS RODRIGO ULLOA GONZÁLEZ",
  commune: "CUNCO",
  displayName: "OCTAVA NOTARÍA DE CUNCO, DE DON 8A NOTARÍA TEMUCO ASIENTO COMUNA DE CUNCO, CONSERVADOR DE BIENES RAÍCES - CARLOS RODRIGO ULLOA GONZÁLEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA FRANCISCA VERGARA WILLIAMS",
  commune: "LONCOCHE",
  displayName: "NOTARÍA NOTARÍA DE LONCOCHE, DE DOÑA NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA FRANCISCA VERGARA WILLIAMS",
  prefix: "DOÑA"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES - SERGIO RODRIGO SANHUEZA RÍOS",
  commune: "NUEVA TOLTÉN",
  displayName: "NOTARÍA NOTARÍA DE NUEVA TOLTÉN, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES - SERGIO RODRIGO SANHUEZA RÍOS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA CONSTANZA CONTARDO SILVA",
  commune: "PITRUFQUÉN",
  displayName: "NOTARÍA NOTARÍA DE PITRUFQUÉN, DE DOÑA CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA CONSTANZA CONTARDO SILVA",
  prefix: "DOÑA"
},
{
  num: "NOTARÍA",
  name: "1° NOTARÍA - GABRIEL ALFONSO FERRAND MIRANDA",
  commune: "PITRUFQUÉN",
  displayName: "NOTARÍA NOTARÍA DE PITRUFQUÉN, DE DON 1° NOTARÍA - GABRIEL ALFONSO FERRAND MIRANDA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - JOSE APOLONIO PEÑA MEZA",
  commune: "VILLARRICA",
  displayName: "NOTARÍA NOTARÍA DE VILLARRICA, DE DON CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - JOSE APOLONIO PEÑA MEZA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE MINAS - FRANCISCO JAVIER MUÑOZ FLORES",
  commune: "VILLARRICA",
  displayName: "NOTARÍA NOTARÍA DE VILLARRICA, DE DON NOTARÍA Y CONSERVADOR DE MINAS - FRANCISCO JAVIER MUÑOZ FLORES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - GONZALO GARAY BURNAS",
  commune: "NUEVA IMPERIAL",
  displayName: "NOTARÍA NOTARÍA DE NUEVA IMPERIAL, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - GONZALO GARAY BURNAS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - SERGIO ENRIQUE ROSSEL RICCI",
  commune: "PUCÓN",
  displayName: "NOTARÍA NOTARÍA DE PUCÓN, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - SERGIO ENRIQUE ROSSEL RICCI",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA - LUIS ENRIQUE ESPINOZA GARRIDO",
  commune: "PUCÓN",
  displayName: "NOTARÍA NOTARÍA DE PUCÓN, DE DON NOTARÍA - LUIS ENRIQUE ESPINOZA GARRIDO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA ANTONIETA SUÁREZ CASTRO",
  commune: "LAUTARO",
  displayName: "NOTARÍA NOTARÍA DE LAUTARO, DE DOÑA NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - MARÍA ANTONIETA SUÁREZ CASTRO",
  prefix: "DOÑA"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - GONZALO PATRICIO CRUZ GUTIERREZ",
  commune: "LAUTARO",
  displayName: "PRIMERA NOTARÍA DE LAUTARO, DE DON 1A NOTARÍA - GONZALO PATRICIO CRUZ GUTIERREZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "2° NOTARÍA LAUTARO ASIENTO COMUNA DE GALVARINO - PAULINA HUINCA (INTERINA)",
  commune: "GALVARINO",
  displayName: "NOTARÍA NOTARÍA DE GALVARINO, DE DON 2° NOTARÍA LAUTARO ASIENTO COMUNA DE GALVARINO - PAULINA HUINCA (INTERINA)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JOSÉ ANDRES PADILLA FLORES",
  commune: "CARAHUE",
  displayName: "NOTARÍA NOTARÍA DE CARAHUE, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JOSÉ ANDRES PADILLA FLORES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - TEODORO CROQUEVIELLE BRAND",
  commune: "VALDIVIA",
  displayName: "NOTARÍA NOTARÍA DE VALDIVIA, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - TEODORO CROQUEVIELLE BRAND",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - PABLO VALENZUELA PÉREZ",
  commune: "VALDIVIA",
  displayName: "PRIMERA NOTARÍA DE VALDIVIA, DE DON 1A NOTARÍA - PABLO VALENZUELA PÉREZ",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - ELIZABETH PACHECO SALGADO",
  commune: "VALDIVIA",
  displayName: "SEGUNDA NOTARÍA DE VALDIVIA, DE DON 2A NOTARÍA - ELIZABETH PACHECO SALGADO",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - LUIS NAVARRETE VILLEGAS",
  commune: "VALDIVIA",
  displayName: "TERCERA NOTARÍA DE VALDIVIA, DE DON 3A NOTARÍA - LUIS NAVARRETE VILLEGAS",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - JUAN BAUTISTA RODRÍGUEZ RUÍZ",
  commune: "VALDIVIA",
  displayName: "CUARTA NOTARÍA DE VALDIVIA, DE DON 4A NOTARÍA - JUAN BAUTISTA RODRÍGUEZ RUÍZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUAN PABLO LEBEDINA ROMO",
  commune: "OF. 1 , SAN JOSÉ DE LA M.",
  displayName: "NOTARÍA NOTARÍA DE OF. 1 , SAN JOSÉ DE LA M., DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUAN PABLO LEBEDINA ROMO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA - GINO MENCARINI SOLERVICENS",
  commune: "SAN JOSÉ DE LA M.",
  displayName: "NOTARÍA NOTARÍA DE SAN JOSÉ DE LA M., DE DON NOTARÍA - GINO MENCARINI SOLERVICENS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CARLOS A. OCAMPO BUSTOS",
  commune: "LOS LAGOS",
  displayName: "NOTARÍA NOTARÍA DE LOS LAGOS, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CARLOS A. OCAMPO BUSTOS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - ANTONIETA MARINA ROJAS PONTIGO",
  commune: "LOS LAGOS",
  displayName: "PRIMERA NOTARÍA DE LOS LAGOS, DE DON 1A NOTARÍA - ANTONIETA MARINA ROJAS PONTIGO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - LEONARDO CALDERARA EMALDIA",
  commune: "PANGUIPULLI",
  displayName: "NOTARÍA NOTARÍA DE PANGUIPULLI, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - LEONARDO CALDERARA EMALDIA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CONRAD PABLO ZÜLCH PARRA",
  commune: "PAILLACO",
  displayName: "NOTARÍA NOTARÍA DE PAILLACO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CONRAD PABLO ZÜLCH PARRA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALBERTO GALILEA SOLA",
  commune: "LA UNIÓN",
  displayName: "NOTARÍA NOTARÍA DE LA UNIÓN, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALBERTO GALILEA SOLA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA - ALEJANDRA ANGULO SANDOVAL",
  commune: "LA UNIÓN",
  displayName: "NOTARÍA NOTARÍA DE LA UNIÓN, DE DON NOTARÍA - ALEJANDRA ANGULO SANDOVAL",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALVARO MEDINA VILLANUEVA (INTERINO)",
  commune: "RÍO BUENO",
  displayName: "NOTARÍA NOTARÍA DE RÍO BUENO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALVARO MEDINA VILLANUEVA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - VICTOR HUGO QUIÑONES SOBARZO",
  commune: "OSORNO",
  displayName: "NOTARÍA NOTARÍA DE OSORNO, DE DON CONSERVADOR DE BIENES RAÍCES, COMERCIO Y ARCHIVERO JUDICIAL - VICTOR HUGO QUIÑONES SOBARZO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA Y CONSERVADOR DE MINAS - SEBASTIÁN SADÁ AZNAR",
  commune: "OSORNO",
  displayName: "PRIMERA NOTARÍA DE OSORNO, DE DON 1A NOTARÍA Y CONSERVADOR DE MINAS - SEBASTIÁN SADÁ AZNAR",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - PABLO ANDRÉS EISENDECHER BERTIN",
  commune: "OSORNO",
  displayName: "SEGUNDA NOTARÍA DE OSORNO, DE DON 2A NOTARÍA - PABLO ANDRÉS EISENDECHER BERTIN",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - ABDALLAH FERNÁNDEZ ATUEZ",
  commune: "OSORNO",
  displayName: "TERCERA NOTARÍA DE OSORNO, DE DON 3A NOTARÍA - ABDALLAH FERNÁNDEZ ATUEZ",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - NICOLÁS VALENZUELA (INTERINO)",
  commune: "",
  displayName: "CUARTA NOTARÍA DE , DE DON 4A NOTARÍA - NICOLÁS VALENZUELA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES - RODRIGO FERRER FIGUEROA",
  commune: "RÍO NEGRO",
  displayName: "NOTARÍA NOTARÍA DE RÍO NEGRO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES - RODRIGO FERRER FIGUEROA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JORGE MARTÍNEZ BARRIENTOS",
  commune: "PUERTO MONTT",
  displayName: "NOTARÍA NOTARÍA DE PUERTO MONTT, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JORGE MARTÍNEZ BARRIENTOS",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - HERNÁN GÓMEZ BROWN (INTERINO)",
  commune: "PUERTO MONTT",
  displayName: "PRIMERA NOTARÍA DE PUERTO MONTT, DE DON HERNÁN GÓMEZ BROWN (INTERINO)",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - FELIPE RICARDO SAN MARTÍN SCHRÖDER",
  commune: "PUERTO MONTT",
  displayName: "SEGUNDA NOTARÍA DE PUERTO MONTT, DE DON FELIPE RICARDO SAN MARTÍN SCHRÖDER",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - HERIBERTO BARRIENTOS BAHAMONDE",
  commune: "PUERTO MONTT",
  displayName: "TERCERA NOTARÍA DE PUERTO MONTT, DE DON HERIBERTO BARRIENTOS BAHAMONDE",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA - PAULA MÉNDEZ GALLARDO (INTERINO)",
  commune: "PUERTO MONTT",
  displayName: "CUARTA NOTARÍA DE PUERTO MONTT, DE PAULA MÉNDEZ GALLARDO (INTERINO)",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - LEBBY BARRÍA GUTIÉRREZ",
  commune: "PUERTO MONTT",
  displayName: "QUINTA NOTARÍA DE PUERTO MONTT, DE DON LEBBY BARRÍA GUTIÉRREZ",
  prefix: "DON"
},
{
  num: "QUINTA",
  name: "5A NOTARÍA - JUAN CARLOS CABEZAS CEPEDA",
  commune: "PUERTO MONTT",
  displayName: "SEXTA NOTARÍA DE PUERTO MONTT, DE DON JUAN CARLOS CABEZAS CEPEDA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - BENJAMIN VERGARA HERNÁNDEZ",
  commune: "PUERTO VARAS",
  displayName: "NOTARÍA NOTARÍA DE PUERTO VARAS, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - BENJAMIN VERGARA HERNÁNDEZ",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - BERNARDO ESPINOSA BANCALARI",
  commune: "PUERTO VARAS",
  displayName: "PRIMERA NOTARÍA DE PUERTO VARAS, DE DON BERNARDO ESPINOSA BANCALARI",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - SANDRA CÁRCAMO VELÁSQUEZ",
  commune: "PUERTO VARAS",
  displayName: "TERCERA NOTARÍA DE PUERTO VARAS, DE DON SANDRA CÁRCAMO VELÁSQUEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA PUERTO VARAS ASIENTO COMUNA DE LLANQUIHUE - RICARDO FONTECILLA GALLARDO",
  commune: "LLANQUIHUE",
  displayName: "NOTARÍA NOTARÍA DE LLANQUIHUE, DE DON NOTARÍA PUERTO VARAS ASIENTO COMUNA DE LLANQUIHUE - RICARDO FONTECILLA GALLARDO",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA DE PUERTO VARAS CON ASIENTO COMUNA DE FRESIA - PAMELA HERNÁNDEZ VALENCIA (INTERINA)",
  commune: "FRESIA",
  displayName: "NOTARÍA NOTARÍA DE FRESIA, DE DON NOTARÍA DE PUERTO VARAS CON ASIENTO COMUNA DE FRESIA - PAMELA HERNÁNDEZ VALENCIA (INTERINA)",
  prefix: "DON"
},
{
  num: "CUARTA",
  name: "4A NOTARÍA DE PUERTO VARAS CON ASIENTO COMUNA DE FRUTILLAR - RODRIGO ANDRÉS PALOMO TORNVALL",
  commune: "FRUTILLAR ALTO, FRUTILLAR",
  displayName: "CUARTA NOTARÍA DE FRUTILLAR ALTO, FRUTILLAR, DE DON 4A NOTARÍA DE PUERTO VARAS CON ASIENTO COMUNA DE FRUTILLAR - RODRIGO ANDRÉS PALOMO TORNVALL",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ELENA RAMÍREZ CATALÁN",
  commune: "HORNOPIRÉN",
  displayName: "NOTARÍA NOTARÍA DE HORNOPIRÉN, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ELENA RAMÍREZ CATALÁN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - BORIS EUDALDO NAVARRO ALARCÓN",
  commune: "CALBUCO",
  displayName: "NOTARÍA NOTARÍA DE CALBUCO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - BORIS EUDALDO NAVARRO ALARCÓN",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - PAMELA ALEJANDRA QUINTEROS LÓPEZ",
  commune: "MAULLÍN",
  displayName: "NOTARÍA NOTARÍA DE MAULLÍN, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - PAMELA ALEJANDRA QUINTEROS LÓPEZ",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - CLAUDIA BRAHM BAHAMONDE",
  commune: "LOS MUERMOS",
  displayName: "NOTARÍA NOTARÍA DE LOS MUERMOS, DE DON NOTARÍA Y CONSERVADOR DE BIENES RAÍCES - CLAUDIA BRAHM BAHAMONDE",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ENRIQUE MONASTERIO REBOLLEDO",
  commune: "CASTRO",
  displayName: "NOTARÍA NOTARÍA DE CASTRO, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ENRIQUE MONASTERIO REBOLLEDO",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - CLAUDIA VELÁSQUEZ TRUJILLO",
  commune: "CASTRO",
  displayName: "PRIMERA NOTARÍA DE CASTRO, DE DON 1A NOTARÍA - CLAUDIA VELÁSQUEZ TRUJILLO",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - CRISTOPHER ANDRÉS ROLACK FUENTES",
  commune: "CASTRO",
  displayName: "SEGUNDA NOTARÍA DE CASTRO, DE DON 2A NOTARÍA - CRISTOPHER ANDRÉS ROLACK FUENTES",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAICES Y ARCHIVERO JUDICIAL - NICOLÁS CONSTENLA NOVOA",
  commune: "ANCUD",
  displayName: "NOTARÍA NOTARÍA DE ANCUD, DE DON NOTARÍA, CONSERVADOR DE BIENES RAICES Y ARCHIVERO JUDICIAL - NICOLÁS CONSTENLA NOVOA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "SECRETARIO, NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y RECEPTOR JUDICIAL - BRUNO ENEAS CASALE MORRISON",
  commune: "ACHAO",
  displayName: "NOTARÍA NOTARÍA DE ACHAO, DE DON SECRETARIO, NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y RECEPTOR JUDICIAL - BRUNO ENEAS CASALE MORRISON",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES - CLAUDIO CABELLO OLAVARRÍA",
  commune: "QUELLÓN",
  displayName: "NOTARÍA NOTARÍA DE QUELLÓN, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES - CLAUDIO CABELLO OLAVARRÍA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - TATIANA BARRIENTOS ALBRECHT",
  commune: "CHAITÉN",
  displayName: "NOTARÍA NOTARÍA DE CHAITÉN, DE DOÑA NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - TATIANA BARRIENTOS ALBRECHT",
  prefix: "DOÑA"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES ASIENTO COMUNA DE FUTALEUFÚ - PATRICIA BARRIENTOS CÁRDENAS",
  commune: "FUTALEUFÚ",
  displayName: "NOTARÍA NOTARÍA DE FUTALEUFÚ, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES ASIENTO COMUNA DE FUTALEUFÚ - PATRICIA BARRIENTOS CÁRDENAS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUAN CARLOS SAN MARTÍN MOLINA",
  commune: "COYHAIQUE",
  displayName: "NOTARÍA NOTARÍA DE COYHAIQUE, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - JUAN CARLOS SAN MARTÍN MOLINA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - MATIAS ROBERTO RAND GONZÁLEZ",
  commune: "COYHAIQUE",
  displayName: "PRIMERA NOTARÍA DE COYHAIQUE, DE DON 1A NOTARÍA - MATIAS ROBERTO RAND GONZÁLEZ",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - DARWIN CONTRERAS PIDERIT",
  commune: "COYHAIQUE",
  displayName: "SEGUNDA NOTARÍA DE COYHAIQUE, DE DON 2A NOTARÍA - DARWIN CONTRERAS PIDERIT",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - DAVID ALONSO VERGARA TORRES",
  commune: "PTO. AYSÉN",
  displayName: "NOTARÍA NOTARÍA DE PTO. AYSÉN, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - DAVID ALONSO VERGARA TORRES",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - CRISTIAN CALDERÓN AMÉSTICA",
  commune: "PTO. AYSÉN",
  displayName: "PRIMERA NOTARÍA DE PTO. AYSÉN, DE DON 1A NOTARÍA - CRISTIAN CALDERÓN AMÉSTICA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL, FERNANDO CRISTIÁN ARANCIBIA MEZA",
  commune: "PUERTO CISNES",
  displayName: "NOTARÍA NOTARÍA DE PUERTO CISNES, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL, FERNANDO CRISTIÁN ARANCIBIA MEZA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALEJANDRO JAVIER DOBBS ROA",
  commune: "CHILE CHICO",
  displayName: "NOTARÍA NOTARÍA DE CHILE CHICO, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - ALEJANDRO JAVIER DOBBS ROA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - HÉCTOR FERNANDO CÁCERES HUBE",
  commune: "COCHRANE",
  displayName: "NOTARÍA NOTARÍA DE COCHRANE, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - HÉCTOR FERNANDO CÁCERES HUBE",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - IGOR TRINCADO URRA",
  commune: "PUNTA ARENAS",
  displayName: "NOTARÍA NOTARÍA DE PUNTA ARENAS, DE DON CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - IGOR TRINCADO URRA",
  prefix: "DON"
},
{
  num: "PRIMERA",
  name: "1A NOTARÍA - HORACIO SILVA REYES",
  commune: "PUNTA ARENAS",
  displayName: "PRIMERA NOTARÍA DE PUNTA ARENAS, DE DON 1A NOTARÍA - HORACIO SILVA REYES",
  prefix: "DON"
},
{
  num: "SEGUNDA",
  name: "2A NOTARÍA - JOSÉ ANTONIO MARTÍNEZ DEMANDES",
  commune: "PUNTA ARENAS",
  displayName: "SEGUNDA NOTARÍA DE PUNTA ARENAS, DE DON 2A NOTARÍA - JOSÉ ANTONIO MARTÍNEZ DEMANDES",
  prefix: "DON"
},
{
  num: "TERCERA",
  name: "3A NOTARÍA - IVÁN TOLEDO MORA (INTERINO)",
  commune: "PUNTA ARENAS",
  displayName: "TERCERA NOTARÍA DE PUNTA ARENAS, DE DON 3A NOTARÍA - IVÁN TOLEDO MORA (INTERINO)",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES - HELBERT MUNDY CASANOVA",
  commune: "PUERTO NATALES",
  displayName: "NOTARÍA NOTARÍA DE PUERTO NATALES, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES - HELBERT MUNDY CASANOVA",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CRISTIAN MATUS CUEVAS",
  commune: "PORVENIR",
  displayName: "NOTARÍA NOTARÍA DE PORVENIR, DE DON NOTARÍA, CONSERVADOR DE BIENES RAÍCES Y ARCHIVERO JUDICIAL - CRISTIAN MATUS CUEVAS",
  prefix: "DON"
},
{
  num: "NOTARÍA",
  name: "NOTARÍA PÚBLICA, CONSERVADOR DE BIENES RAÍCES, ARCHIVERO - RICARDO HERRERA CASTILLO",
  commune: "CABO DE HORNOS",
  displayName: "NOTARÍA NOTARÍA DE CABO DE HORNOS, DE DON NOTARÍA PÚBLICA, CONSERVADOR DE BIENES RAÍCES, ARCHIVERO - RICARDO HERRERA CASTILLO",
  prefix: "DON"
}
];